/* Ability Warehouse — Help me choose (collection chooser) + Is this right for me? (product fit check).
   One module, three modes picked by the page markup (snippets/aw-choose.liquid):
     collection  [data-hmc]        3–5 questions tailored to the collection → ranks the grid via window.CWCatalog
     product     [data-fitcheck]   2–5 questions about the person → ✓ / ! / ✗ verdict from fit.* data + alternatives
     account     [data-fit-account] "Your fit profile" card on customers/account
   Shared: question sets (assets/aw-choose.json), the rule evaluator, answer memory (localStorage awFit:v2),
   result cards (CWIndex.card), the "search our entire range" block and the sourcing enquiry form.
   Vanilla JS, no dependencies beyond window.CWIndex (assets/cw-index.js) and window.AWUnderstand. */
(function () {
  'use strict';
  if (window.AWChoose) return;
  var X = window.CWIndex;
  if (!X) return;
  var esc = X.esc, money = X.money;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESK = function () { return window.innerWidth >= 990; };
  var headerH = function () { return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0; };

  /* =========================================================================
     1. Answer memory — person-level details shared by every page
     ========================================================================= */
  var Mem = (function () {
    var KEY = 'awFit:v2', OLD = 'awFit:v1';
    var KEYS = ['height_cm', 'weight_kg', 'doorway_cm', 'hand_strength', 'side', 'waist_size', 'who_for'];
    function read(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
    function get() {
      var m = read(KEY);
      if (!m) {
        // migrate the v1 profile written by assets/aw-help.js ({weight, height, door})
        var o = read(OLD) || {};
        m = {};
        if (o.height) m.height_cm = +o.height;
        if (o.weight) m.weight_kg = +o.weight;
        if (o.door) m.doorway_cm = +o.door;
        if (Object.keys(m).length) write(m);
      }
      return m || {};
    }
    function write(m) {
      try { localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {}
      // keep the v1 profile in step so the existing "Fits you" badges (aw-help.js) agree with the fit check
      try {
        var o = read(OLD) || {};
        if (m.height_cm) o.height = m.height_cm; if (m.weight_kg) o.weight = m.weight_kg; if (m.doorway_cm) o.door = m.doorway_cm;
        localStorage.setItem(OLD, JSON.stringify(o));
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('awfit:change'));
    }
    function set(k, v) { var m = get(); if (v == null || v === '') delete m[k]; else m[k] = v; write(m); }
    function hasNumbers() { var m = get(); return !!(m.height_cm || m.weight_kg || m.doorway_cm); }
    return { get: get, set: set, write: write, keys: KEYS, hasNumbers: hasNumbers };
  })();

  /* =========================================================================
     2. Config + rule evaluator
     ========================================================================= */
  var cfgPromise = null;
  function config(url) {
    if (!cfgPromise) cfgPromise = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    return cfgPromise;
  }
  function hay(it) {
    if (!it._hay2) it._hay2 = [it.t, it.pt, (it.tg || []).join(' ').replace(/-/g, ' '), it.uf].join(' ').toLowerCase();
    return it._hay2;
  }
  function optValues(it) {
    if (!it._ov) { var out = []; var op = it.op || {}; Object.keys(op).forEach(function (k) { (op[k] || []).forEach(function (v) { out.push(String(v).toLowerCase()); }); }); it._ov = out; }
    return it._ov;
  }
  function wr(it) { if (it.fit && it.fit.max_user_weight_kg) return +it.fit.max_user_weight_kg; var m = String(it.wr || '').match(/\d+/); return m ? +m[0] : 0; }
  function widthOf(it) { if (it.fit && it.fit.overall_width_cm) return +it.fit.overall_width_cm; var m = String(it.wd || '').match(/\d+/); return m ? +m[0] : 0; }
  var reCache = {};
  function rx(s) { return reCache[s] || (reCache[s] = new RegExp(s, 'i')); }
  /* evalRule → true / false / null (null = the product has no data for this rule: passes, scores nothing) */
  function evalRule(r, it) {
    if (!r) return null;
    if (r.any) { var sawNull = false; for (var i = 0; i < r.any.length; i++) { var v = evalRule(r.any[i], it); if (v === true) return true; if (v === null) sawNull = true; } return sawNull ? null : false; }
    if (r.all) { var nul = false; for (var j = 0; j < r.all.length; j++) { var w = evalRule(r.all[j], it); if (w === false) return false; if (w === null) nul = true; } return nul ? null : true; }
    if (r.not) { var n = evalRule(r.not, it); return n === null ? null : !n; }
    if (r.tag) return (it.tg || []).indexOf(r.tag) > -1;
    if (r.tagAny) { for (var k = 0; k < r.tagAny.length; k++) if ((it.tg || []).indexOf(r.tagAny[k]) > -1) return true; return false; }
    if (r.re !== undefined) return r.re === '' ? true : rx(r.re).test(hay(it));
    if (r.type) return Array.isArray(r.type) ? r.type.indexOf(it.pt) > -1 : it.pt === r.type;
    if (r.typeRe) return rx(r.typeRe).test(it.pt || '');
    if (r.useFor) return String(it.uf || '').toLowerCase().indexOf(String(r.useFor).toLowerCase()) > -1;
    if (r.optAny) { var ov = optValues(it); for (var q = 0; q < r.optAny.length; q++) { var want = String(r.optAny[q]).toLowerCase(); for (var z = 0; z < ov.length; z++) if (ov[z] === want || ov[z].split(/[^a-z0-9]+/).indexOf(want) > -1) return true; } return false; }
    if (r.weightMin !== undefined) { var w2 = wr(it); return w2 ? w2 >= r.weightMin : null; }
    if (r.widthMax !== undefined) { var wd = widthOf(it); return wd ? wd <= r.widthMax : null; }
    if (r.priceMin !== undefined || r.priceMax !== undefined) {
      var d = (it.per || it.p || 0) / 100;
      if (r.priceMin !== undefined && d < r.priceMin) return false;
      if (r.priceMax !== undefined && d >= r.priceMax) return false;
      return true;
    }
    if (r.fit) {
      var f = it.fit || {}, val = f[r.fit.key];
      if (val === undefined || val === null || val === '') return null;
      if (r.fit.eq !== undefined) return String(val).toLowerCase() === String(r.fit.eq).toLowerCase();
      var num = +val; if (isNaN(num)) return null;
      if (r.fit.min !== undefined && num < r.fit.min) return false;
      if (r.fit.max !== undefined && num > r.fit.max) return false;
      return true;
    }
    return null;
  }

  /* family for a collection ({handle, tags}) or a product ({tags, type}); first match wins.
     A product's own type decides first (a seat walker tagged cat-wheelchairs is still a walker); handles and tags after. */
  function matchFamily(cfg, ctx) {
    var tags = ctx.tags || [], type = ctx.type || '', handle = ctx.handle || '';
    var catTags = tags.map(function (t) { return t.replace(/^(cat|dept)-/, ''); });
    var i, fam, m;
    if (type) for (i = 0; i < cfg.families.length; i++) { fam = cfg.families[i]; m = fam.match || {}; if (m.typeRe && rx(m.typeRe).test(type)) return fam; }
    for (i = 0; i < cfg.families.length; i++) {
      fam = cfg.families[i]; m = fam.match || {};
      if (m.always) return fam;
      var hs = m.handles || [], ps = m.prefixes || [], ts = m.tags || [];
      var hit = hs.indexOf(handle) > -1 || hs.some(function (h) { return catTags.indexOf(h) > -1; }) ||
        ps.some(function (p) { return handle.indexOf(p) === 0 || catTags.some(function (c) { return c.indexOf(p) === 0; }); }) ||
        ts.some(function (t) { return tags.indexOf(t) > -1; });
      if (hit) return fam;
    }
    return cfg.families[cfg.families.length - 1];
  }
  /* product-type group within a family (fit-check alternatives): first typeGroups re matching the title, then the
     product type; else the product type itself. A seat walker only gets seat walkers/rollators, never canes. */
  function typeGroup(fam, it) {
    var gs = (fam && fam.typeGroups) || [], t = it.t || '', p = it.pt || '', i;
    for (i = 0; i < gs.length; i++) if (rx(gs[i].re).test(t)) return gs[i].id;
    for (i = 0; i < gs.length; i++) if (rx(gs[i].re).test(p)) return gs[i].id;
    return 'pt:' + p.toLowerCase();
  }
  /* collection questions, with the shared weight / budget / height option sets filled in */
  function expand(cfg, fam) {
    return fam.questions.map(function (q) {
      var o = {}; for (var k in q) o[k] = q[k];
      if (q.weight) { o.options = cfg.weightOptions; o.soft = true; o.id = o.id || 'weight'; }
      if (q.budget) { o.options = cfg.budgetOptions; o.soft = true; }
      return o;
    });
  }

  /* =========================================================================
     3. Fit checks — verdict for one product record against the person's answers
        rec.fit = fit.* metafields (see FIT_SCHEMA); ans = {weight_kg, height_cm, doorway_cm, ...}
        Each check → {k, ok: true | 'warn' | false | null, text}. null = nothing to check.
     ========================================================================= */
  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }
  function unconfirmedHas(fit, key) { return String(fit.unconfirmed || '').split(/\s*,\s*/).indexOf(key) > -1; }
  function labelFor(key) {
    return { max_user_weight_kg: 'Max user weight', overall_width_cm: 'Overall width', handle_height_min_cm: 'Handle height range', seat_height_cm: 'Seat height', lift_cm: 'Seat lift', seat_width_cm: 'Seat width', foldable: 'Whether it folds', self_propelled: 'Self-propel wheels', powered: 'Power needs', size_options: 'Sizes', fit_side: 'Which side it fits', bed_width_cm: 'Bed width', product_weight_kg: 'Product weight', overall_length_cm: 'Overall length', width_between_arms_cm: 'Width between the legs', seat_width_min_cm: 'Seat width', lift_cm: 'Seat lift' }[key] || key.replace(/_cm$|_kg$/, '').replace(/_/g, ' ');
  }
  /* "it folds" from free text: folding / foldable / folds (for transport, storage, flat, compactly…), but not a folding
     part (backrest, seat, armrests, footplates…) and not "non-folding" / "does not fold" */
  function foldsByText(text) {
    var re = /\bfold(?:s|ing|able|ed)?\b(?:[\s-]+(?:down|up|away|flat))?/gi, m;
    text = String(text || '');
    while ((m = re.exec(text))) {
      var before = text.slice(Math.max(0, m.index - 12), m.index), after = text.slice(m.index + m[0].length, m.index + m[0].length + 30);
      if (/(non|not|n't|never)[\s-]*$/i.test(before)) continue;
      if (/^[\s-]*(?:and\s+\w+\s+|\w+\s+and\s+)?(?:back\s?rests?|backs?\b|seats?\b(?![\s-]*(?:walker|rollator|chair|commode|stool))|arm\s?rests?|arms?\b|foot\s?plates?|foot\s?rests?|leg\s?rests?|handles?\b|trays?\b|tables?\b|steps?\b|footboards?)/i.test(after)) continue;
      return true;
    }
    return false;
  }
  function needText(key) { return labelFor(key) + " isn't published for this model — we'll confirm it before dispatch"; }
  var CHECKS = {
    weight: function (fit, ans) {
      var kg = num(ans.weight_kg); if (!kg) return null;
      var max = num(fit.max_user_weight_kg);
      if (!max) return { k: 'weight', ok: 'warn', text: needText('max_user_weight_kg') + ' (you entered ' + kg + ' kg)' };
      if (kg > max) return { k: 'weight', ok: false, text: 'Rated to ' + max + ' kg; you entered ' + kg + ' kg' };
      if (kg * 1.1 > max) return { k: 'weight', ok: 'warn', text: 'Rated to ' + max + ' kg — only ' + Math.round(max - kg) + ' kg above the ' + kg + ' kg you entered' };
      return { k: 'weight', ok: true, text: 'Rated to ' + max + ' kg, ' + Math.round(max - kg) + ' kg above the ' + kg + ' kg you entered' };
    },
    height: function (fit, ans) {
      var h = num(ans.height_cm); if (!h) return null;
      var out = [];
      var hmin = num(fit.handle_height_min_cm), hmax = num(fit.handle_height_max_cm);
      if (hmin || hmax) {
        var want = Math.round(h * 0.48); hmin = hmin || hmax; hmax = hmax || hmin;
        if (want < hmin || want > hmax) out.push({ k: 'handle', ok: false, text: 'Handles adjust ' + hmin + '–' + hmax + ' cm; a ' + h + ' cm person usually needs about ' + want + ' cm' });
        else if (want - hmin < 2 || hmax - want < 2) out.push({ k: 'handle', ok: 'warn', text: 'Handles adjust ' + hmin + '–' + hmax + ' cm; about ' + want + ' cm is needed, close to the limit' });
        else out.push({ k: 'handle', ok: true, text: 'Handles adjust ' + hmin + '–' + hmax + ' cm, covering the ' + want + ' cm a ' + h + ' cm person usually needs' });
      } else if (unconfirmedHas(fit, 'handle_height_min_cm')) out.push({ k: 'handle', ok: 'warn', text: needText('handle_height_min_cm') });
      var smin = num(fit.seat_height_min_cm) || num(fit.seat_height_cm), smax = num(fit.seat_height_max_cm) || num(fit.seat_height_cm);
      if (smin || smax) {
        var seat = Math.round(h * 0.27); smin = smin || smax; smax = smax || smin;
        var lo = seat - 4, hi = seat + 4;
        if (smax < lo || smin > hi) out.push({ k: 'seat', ok: false, text: 'Seat height ' + (smin === smax ? smin : smin + '–' + smax) + ' cm; about ' + seat + ' cm (±4) suits a ' + h + ' cm person' });
        else out.push({ k: 'seat', ok: true, text: 'Seat height ' + (smin === smax ? smin : smin + '–' + smax) + ' cm suits a ' + h + ' cm person (about ' + seat + ' cm)' });
      } else if (unconfirmedHas(fit, 'seat_height_cm')) out.push({ k: 'seat', ok: 'warn', text: needText('seat_height_cm') });
      var umin = num(fit.user_height_min_cm), umax = num(fit.user_height_max_cm);
      if (umin || umax) {
        if ((umin && h < umin) || (umax && h > umax)) out.push({ k: 'uheight', ok: false, text: 'Made for people ' + (umin || '?') + '–' + (umax || '?') + ' cm tall; you entered ' + h + ' cm' });
        else out.push({ k: 'uheight', ok: true, text: 'Made for people ' + (umin || '?') + '–' + (umax || '?') + ' cm tall (you entered ' + h + ' cm)' });
      }
      if (!out.length && !fit.confidence) out.push({ k: 'height', ok: 'warn', text: 'Height-related sizes aren’t published for this model — we’ll confirm them before dispatch' });
      return out;
    },
    width: function (fit, ans) {
      var door = num(ans.doorway_cm); if (!door) return null;
      var w = num(fit.overall_width_cm);
      if (!w) return { k: 'width', ok: 'warn', text: needText('overall_width_cm') + ' (your doorway is ' + door + ' cm)' };
      var margin = door - w;
      if (margin < 4) return { k: 'width', ok: false, text: w + ' cm wide; your ' + door + ' cm doorway leaves ' + margin + ' cm, less than the 4 cm needed' };
      if (margin < 6) return { k: 'width', ok: 'warn', text: w + ' cm wide; fits your ' + door + ' cm doorway with ' + margin + ' cm to spare — tight' };
      return { k: 'width', ok: true, text: w + ' cm wide; fits your ' + door + ' cm doorway with ' + margin + ' cm to spare' };
    },
    fold: function (fit, ans, rec) {
      if (ans.fold_need !== 'yes') return null;
      if (fit.foldable === true) return { k: 'fold', ok: true, text: 'Folds for the car' };
      if (fit.foldable === false) return { k: 'fold', ok: false, text: 'Does not fold' };
      // no fit.foldable: fall back to the description (product page) or the title (alternatives) — a pass with a note
      if (foldsByText(((rec && rec._desc) || '') + ' ' + ((rec && rec.t) || ''))) return { k: 'fold', ok: 'note', text: 'The description says it folds — dimensions folded not published' };
      return { k: 'fold', ok: 'warn', text: needText('foldable') };
    },
    lift: function (fit, ans) {
      var want = num(ans.lift_need); if (!want) return null;
      var lift = num(fit.lift_cm);
      if (!lift) return { k: 'lift', ok: 'warn', text: needText('lift_cm') + ' (you need about ' + want + ' cm)' };
      var diff = Math.abs(lift - want);
      if (diff <= 2.5) return { k: 'lift', ok: true, text: 'Raises the seat ' + lift + ' cm, close to the ' + want + ' cm you need' };
      if (diff <= 5) return { k: 'lift', ok: 'warn', text: 'Raises the seat ' + lift + ' cm; you asked for about ' + want + ' cm' };
      return { k: 'lift', ok: false, text: 'Raises the seat ' + lift + ' cm; you need about ' + want + ' cm' };
    },
    seatWidth: function (fit, ans) {
      var band = ans.seat_width_need; if (!band) return null;
      var lo = num(fit.seat_width_min_cm) || num(fit.seat_width_cm), hi = num(fit.seat_width_max_cm) || num(fit.seat_width_cm);
      if (!lo && !hi) return { k: 'seatw', ok: 'warn', text: needText('seat_width_cm') };
      lo = lo || hi; hi = hi || lo;
      var want = band === 's' ? [0, 42.9] : band === 'm' ? [43, 48] : [50, 999];
      var ok = hi >= want[0] && lo <= want[1];
      var txt = 'Seat width ' + (lo === hi ? lo : lo + '–' + hi) + ' cm';
      return { k: 'seatw', ok: ok, text: ok ? txt + ', within the band you chose' : txt + '; you chose ' + (band === 's' ? 'under 43 cm' : band === 'm' ? '43–48 cm' : '50 cm and wider') };
    },
    propel: function (fit, ans) {
      var who = ans.self_propel; if (!who) return null;
      if (who === 'power') { if (fit.powered === true) return { k: 'propel', ok: true, text: 'Powered' }; if (fit.powered === false) return { k: 'propel', ok: false, text: 'Not powered' }; return { k: 'propel', ok: 'warn', text: needText('powered') }; }
      if (who === 'self') { if (fit.self_propelled === true) return { k: 'propel', ok: true, text: 'Self-propel rear wheels' }; if (fit.self_propelled === false) return { k: 'propel', ok: false, text: 'Transit chair — needs someone to push' }; return { k: 'propel', ok: 'warn', text: needText('self_propelled') }; }
      if (fit.self_propelled === false || fit.self_propelled === true) return { k: 'propel', ok: true, text: fit.self_propelled ? 'Self-propel chair; a carer can push it too' : 'Transit chair, made to be pushed' };
      return { k: 'propel', ok: 'warn', text: needText('self_propelled') };
    },
    side: function (fit, ans) {
      var s = ans.side; if (!s) return null;
      var fs = String(fit.fit_side || '').toLowerCase();
      if (!fs) return { k: 'side', ok: 'warn', text: needText('fit_side') };
      if (fs === 'universal' || s === 'either') return { k: 'side', ok: true, text: fs === 'universal' ? 'Fits either side' : 'Made for the ' + fs };
      return fs === s ? { k: 'side', ok: true, text: 'Made for the ' + fs } : { k: 'side', ok: false, text: 'Made for the ' + fs + '; you need the ' + s };
    },
    size: function (fit, ans, rec) {
      var s = ans.size; if (!s) return null;
      var opts = sizeOptions(rec);
      if (!opts.length) return { k: 'size', ok: 'warn', text: needText('size_options') };
      var hit = opts.some(function (o) { return o.toLowerCase() === String(s).toLowerCase(); });
      return hit ? { k: 'size', ok: true, text: 'Comes in ' + s + ' (sizes: ' + opts.join(', ') + ')' } : { k: 'size', ok: false, text: 'Sizes: ' + opts.join(', ') + '; ' + s + ' isn’t one of them' };
    },
    waist: function (fit, ans, rec) {
      var s = ans.waist_size; if (!s) return null;
      var opts = sizeOptions(rec).map(function (o) { return o.toLowerCase(); });
      if (!opts.length) return { k: 'waist', ok: 'warn', text: needText('size_options') };
      var want = { S: /^(s|small)$/, M: /^(m|medium)$/, L: /^(l|large)$/, XL: /^(xl|xxl|x-large|extra large|xxxl)$/ }[s];
      var hit = opts.some(function (o) { return want && want.test(o); });
      return hit ? { k: 'waist', ok: true, text: 'Comes in ' + s + ' (sizes: ' + sizeOptions(rec).join(', ') + ')' } : { k: 'waist', ok: false, text: 'Sizes: ' + sizeOptions(rec).join(', ') + '; no ' + s };
    },
    power: function (fit, ans) {
      if (!ans.power_point) return null;
      if (fit.powered === true && ans.power_point === 'no') return { k: 'power', ok: 'warn', text: 'Needs mains power — plan an extension lead or a closer power point' };
      if (fit.powered === true) return { k: 'power', ok: true, text: 'Needs mains power; you have a point nearby' };
      if (fit.powered === false) return { k: 'power', ok: true, text: 'No power needed' };
      return null;
    },
    bed: function (fit, ans) {
      var b = ans.bed_size; if (!b) return null;
      var w = num(fit.bed_width_cm);
      if (!w) return { k: 'bed', ok: 'warn', text: needText('bed_width_cm') };
      var want = b === 'single' ? [85, 100] : b === 'ks' ? [100, 120] : [140, 220];
      var ok = w >= want[0] && w <= want[1];
      return { k: 'bed', ok: ok, text: ok ? 'Made for a ' + w + ' cm wide bed' : 'Made for a ' + w + ' cm wide bed, not a ' + (b === 'single' ? 'single' : b === 'ks' ? 'king single' : 'queen or larger') };
    },
    recess: function (fit, ans) {
      var r = num(ans.recess_width_cm); if (!r) return null;
      var w = num(fit.overall_width_cm), l = num(fit.overall_length_cm);
      if (!w && !l) return { k: 'recess', ok: 'warn', text: needText('overall_width_cm') + ' (your recess is ' + r + ' cm)' };
      var need = Math.max(w || 0, 0), spare = r - need;
      if (spare < 0) return { k: 'recess', ok: false, text: need + ' cm wide; wider than your ' + r + ' cm recess' };
      if (spare < 10) return { k: 'recess', ok: 'warn', text: need + ' cm wide; fits your ' + r + ' cm recess with only ' + spare + ' cm to spare' };
      return { k: 'recess', ok: true, text: need + ' cm wide' + (l ? ' × ' + l + ' cm deep' : '') + '; fits your ' + r + ' cm recess with ' + spare + ' cm to spare' };
    },
    bath: function (fit, ans) {
      var b = num(ans.bath_width_cm); if (!b) return null;
      var l = num(fit.overall_length_cm) || num(fit.overall_width_cm);
      if (!l) return { k: 'bath', ok: 'warn', text: needText('overall_length_cm') + ' (your bath is ' + b + ' cm inside)' };
      if (l < b + 8) return { k: 'bath', ok: false, text: l + ' cm long; needs to span your ' + b + ' cm bath plus both rims (about ' + (b + 8) + ' cm)' };
      return { k: 'bath', ok: true, text: l + ' cm long; spans your ' + b + ' cm bath with ' + (l - b) + ' cm over the rims' };
    },
    overToilet: function (fit, ans) {
      var t = num(ans.toilet_width_cm); if (!t) return null;
      var w = num(fit.width_between_arms_cm);
      if (!w) return { k: 'overtoilet', ok: 'warn', text: needText('width_between_arms_cm') + ' (your toilet is ' + t + ' cm wide)' };
      if (w < t + 2) return { k: 'overtoilet', ok: false, text: w + ' cm between the legs; your ' + t + ' cm toilet needs at least ' + (t + 2) + ' cm' };
      return { k: 'overtoilet', ok: true, text: w + ' cm between the legs; clears your ' + t + ' cm toilet by ' + (w - t) + ' cm' };
    },
    liftHeight: function (fit, ans) {
      var th = num(ans.toilet_height_cm), h = num(ans.height_cm); if (!th || !h) return null;
      var lift = num(fit.lift_cm);
      var knee = Math.round(h * 0.27), want = Math.max(0, knee - th);
      if (!lift) return { k: 'lifth', ok: 'warn', text: 'You need about ' + want + ' cm of lift (knee height ≈ ' + knee + ' cm, toilet ' + th + ' cm); ' + needText('lift_cm') };
      var diff = Math.abs(lift - want);
      if (diff <= 3) return { k: 'lifth', ok: true, text: 'Raises your ' + th + ' cm toilet to ' + (th + lift) + ' cm, close to the ' + knee + ' cm that suits a ' + h + ' cm person' };
      if (diff <= 6) return { k: 'lifth', ok: 'warn', text: 'Raises your toilet to ' + (th + lift) + ' cm; about ' + knee + ' cm suits a ' + h + ' cm person' };
      return { k: 'lifth', ok: false, text: 'Raises your toilet to ' + (th + lift) + ' cm; a ' + h + ' cm person needs about ' + knee + ' cm (' + want + ' cm of lift)' };
    },
    hip: function (fit, ans) {
      var hip = num(ans.hip_cm); if (!hip) return null;
      var lo = num(fit.seat_width_min_cm) || num(fit.seat_width_cm), hi = num(fit.seat_width_max_cm) || num(fit.seat_width_cm);
      if (!lo && !hi) return { k: 'hip', ok: 'warn', text: needText('seat_width_cm') + ' (your hips are ' + hip + ' cm)' };
      lo = lo || hi; hi = hi || lo;
      var want = [hip + 2, hip + 5], txt = 'Seat width ' + (lo === hi ? lo : lo + '–' + hi) + ' cm';
      if (hi < want[0]) return { k: 'hip', ok: false, text: txt + '; your ' + hip + ' cm hips need ' + want[0] + '–' + want[1] + ' cm' };
      if (lo > want[1] + 3) return { k: 'hip', ok: 'warn', text: txt + '; wider than the ' + want[0] + '–' + want[1] + ' cm that suits ' + hip + ' cm hips (less support when seated)' };
      return { k: 'hip', ok: true, text: txt + ', right for ' + hip + ' cm hips (' + want[0] + '–' + want[1] + ' cm ideal)' };
    },
    chairFit: function (fit, ans) {
      var c = num(ans.chair_seat_width_cm); if (!c) return null;
      var w = num(fit.seat_width_cm) || num(fit.overall_width_cm);
      if (!w) return { k: 'chairfit', ok: 'warn', text: needText('seat_width_cm') + ' (your seat is ' + c + ' cm wide)' };
      if (w > c) return { k: 'chairfit', ok: false, text: w + ' cm wide; too wide for your ' + c + ' cm seat' };
      if (w < c - 6) return { k: 'chairfit', ok: 'warn', text: w + ' cm wide; leaves ' + (c - w) + ' cm spare on your ' + c + ' cm seat' };
      return { k: 'chairfit', ok: true, text: w + ' cm wide; fits your ' + c + ' cm seat' };
    },
    liftCapacity: function (fit, ans) {
      var cap = num(ans.lift_capacity); if (!cap) return null;
      var pw = num(fit.product_weight_kg);
      if (!pw) return { k: 'liftcap', ok: 'warn', text: needText('product_weight_kg') + ' (you can lift up to ' + cap + ' kg)' };
      if (cap >= 20) return { k: 'liftcap', ok: true, text: 'Weighs ' + pw + ' kg' };
      if (pw > cap) return { k: 'liftcap', ok: 'warn', text: 'Weighs ' + pw + ' kg, more than the ' + cap + ' kg you can comfortably lift' };
      return { k: 'liftcap', ok: true, text: 'Weighs ' + pw + ' kg, within the ' + cap + ' kg you can lift' };
    },
    railLength: function (fit, ans) {
      var want = num(ans.rail_length_cm); if (!want) return null;
      var l = num(fit.overall_length_cm);
      if (!l) return { k: 'rail', ok: 'warn', text: needText('overall_length_cm') + ' (you want about ' + want + ' cm)' };
      if (Math.abs(l - want) <= 10) return { k: 'rail', ok: true, text: l + ' cm long, close to the ' + want + ' cm you want' };
      return { k: 'rail', ok: 'warn', text: l + ' cm long; you asked for about ' + want + ' cm' };
    },
    reachLength: function (fit, ans) {
      var r = ans.reach_need; if (!r) return null;
      var l = num(fit.overall_length_cm);
      if (!l) return { k: 'reach', ok: 'warn', text: needText('overall_length_cm') };
      var ok = r === 'short' ? l >= 55 : l >= 80;
      return { k: 'reach', ok: ok ? true : 'warn', text: l + ' cm long; ' + (ok ? 'suits ' : 'may be short for ') + (r === 'short' ? 'chair-to-floor reaching' : 'high shelves or reaching from bed') };
    },
    chest: function (fit, ans, rec) {
      var c = num(ans.chest_cm); if (!c) return null;
      var opts = sizeOptions(rec);
      if (!opts.length) return { k: 'chest', ok: 'warn', text: needText('size_options') + ' (chest ' + c + ' cm)' };
      var band = c < 90 ? 'S' : c < 110 ? 'M' : c < 130 ? 'L' : 'XL';
      var hit = opts.some(function (o) { return o.toUpperCase().replace(/\s/g, '') === band || (band === 'XL' && /XXL|XL/.test(o.toUpperCase())); });
      return hit ? { k: 'chest', ok: true, text: 'Comes in ' + band + ', the usual size for a ' + c + ' cm chest (sizes: ' + opts.join(', ') + ')' } : { k: 'chest', ok: 'warn', text: 'A ' + c + ' cm chest usually takes ' + band + '; sizes sold: ' + opts.join(', ') + ' — we’ll confirm' };
    },
    cuff: function (fit, ans, rec) {
      var c = num(ans.cuff_cm); if (!c) return null;
      var opts = sizeOptions(rec), so = String((rec.fit || {}).size_options || '');
      var m = so.match(/(\d+)\s*[–-]\s*(\d+)\s*cm/);
      if (m) { var ok = c >= +m[1] && c <= +m[2]; return { k: 'cuff', ok: ok, text: 'Cuff fits ' + m[1] + '–' + m[2] + ' cm arms; yours is ' + c + ' cm' }; }
      if (opts.length) return { k: 'cuff', ok: 'warn', text: 'Cuff sizes: ' + opts.join(', ') + ' — we’ll confirm which suits a ' + c + ' cm arm' };
      return { k: 'cuff', ok: 'warn', text: needText('size_options') + ' (your arm is ' + c + ' cm)' };
    },
    frameFit: function (fit, ans, rec) {
      var b = ans.frame_size; if (!b) return null;
      var w = num(fit.bed_width_cm), opts = sizeOptions(rec).map(function (o) { return o.toLowerCase(); });
      var want = { single: [85, 100], ks: [100, 120], double: [130, 145], queen: [145, 220] }[b], lbl = { single: 'single', ks: 'king single', double: 'double', queen: 'queen or larger' }[b];
      if (w) { var ok = w >= want[0] && w <= want[1]; return { k: 'frame', ok: ok, text: ok ? w + ' cm wide, made for a ' + lbl : w + ' cm wide; not a ' + lbl + ' size' }; }
      if (opts.length) { var hit = opts.some(function (o) { return o.indexOf(b === 'ks' ? 'king single' : b === 'queen' ? 'queen' : b) > -1 || (b === 'queen' && /king\b/.test(o)); }); return { k: 'frame', ok: hit ? true : false, text: hit ? 'Comes in ' + lbl + ' (sizes: ' + sizeOptions(rec).join(', ') + ')' : 'Sizes: ' + sizeOptions(rec).join(', ') + '; no ' + lbl }; }
      return { k: 'frame', ok: 'warn', text: needText('bed_width_cm') };
    },
    powerSource: function (fit, ans) {
      var p = ans.power_source; if (!p || p === 'any') return null;
      if (fit.powered === true && p === 'battery') return { k: 'psrc', ok: 'warn', text: 'Needs mains power; you wanted battery' };
      if (fit.powered === false && p === 'mains') return { k: 'psrc', ok: true, text: 'Runs on battery, no cord needed' };
      if (fit.powered === true || fit.powered === false) return { k: 'psrc', ok: true, text: fit.powered ? 'Mains powered' : 'Battery powered' };
      return null;
    },
    terrain: function () { return null; }, mount: function () { return null; }, app: function () { return null; }, alertWho: function () { return null; },
    range: function () { return null; }, wearWhere: function () { return null; }, dayNight: function () { return null; }, disposable: function () { return null; },
    risk: function () { return null; }, quantity: function () { return null; },
    stand: function (fit, ans) { return null; },
    absorbency: function (fit, ans) { return null; },
    grip: function (fit, ans) { return null; },
    purpose: function (fit, ans) { return null; }
  };

  /* =========================================================================
     3b. "Usual questions" — one-line answers computed from fit.* / options / description facts (never guessed).
         Each QA(rec, ans, F) → { q, ok: true | 'warn' | false | 'unknown', text, input? }. `input` names the
         questionnaire question whose answer drives the line. F = facts from the page (description text etc.).
     ========================================================================= */
  var NOTPUB = 'Not published for this model — we’ll confirm it for you';
  function descHas(F, re) { return rx(re).test(F.desc || ''); }
  function descGrab(F, re) { var m = (F.desc || '').match(new RegExp(re, 'i')); return m ? m[0] : ''; }
  function sentence(F, re) { var m = (F.desc || '').match(new RegExp('[^.]*(' + re + ')[^.]*\\.', 'i')); return m ? m[0].trim() : ''; }
  var QA = {
    doorway: function (rec, ans, F) {
      var fit = rec.fit, w = num(fit.overall_width_cm);
      if (ans.doorway_cm && w) { var c = CHECKS.width(fit, ans); return { q: 'Will it fit through my doorway?', ok: c.ok, text: c.text, input: 'doorway_cm' }; }
      if (w) return { q: 'Will it fit through my doorway?', ok: w <= 73 ? true : 'warn', text: 'Overall width ' + w + ' cm; ' + (w <= 73 ? 'fits a standard 77 cm doorway' : 'tight for a standard 77 cm doorway — measure yours'), input: 'doorway_cm' };
      return { q: 'Will it fit through my doorway?', ok: 'unknown', text: NOTPUB, input: 'doorway_cm' };
    },
    handle: function (rec, ans, F) {
      var fit = rec.fit, lo = num(fit.handle_height_min_cm), hi = num(fit.handle_height_max_cm);
      if (!lo && !hi) return { q: 'Is the handle height right for me?', ok: 'unknown', text: NOTPUB, input: 'height_cm' };
      lo = lo || hi; hi = hi || lo;
      if (ans.height_cm) { var cs = (CHECKS.height(fit, ans) || []).filter(function (c) { return c.k === 'handle'; })[0]; if (cs) return { q: 'Is the handle height right for me?', ok: cs.ok, text: cs.text, input: 'height_cm' }; }
      return { q: 'Is the handle height right for me?', ok: true, text: 'Handles adjust ' + lo + '–' + hi + ' cm, suiting people about ' + Math.round(lo / 0.48) + '–' + Math.round(hi / 0.48) + ' cm tall', input: 'height_cm' };
    },
    seat: function (rec, ans, F) {
      var fit = rec.fit, lo = num(fit.seat_height_min_cm) || num(fit.seat_height_cm), hi = num(fit.seat_height_max_cm) || num(fit.seat_height_cm);
      if (!lo && !hi) return { q: 'Will the seat height suit me?', ok: 'unknown', text: NOTPUB, input: 'height_cm' };
      lo = lo || hi; hi = hi || lo;
      if (ans.height_cm) { var cs = (CHECKS.height(fit, ans) || []).filter(function (c) { return c.k === 'seat'; })[0]; if (cs) return { q: 'Will the seat height suit me?', ok: cs.ok, text: cs.text, input: 'height_cm' }; }
      return { q: 'Will the seat height suit me?', ok: true, text: 'Seat height ' + (lo === hi ? lo : lo + '–' + hi) + ' cm, suiting people about ' + Math.round((lo - 4) / 0.27) + '–' + Math.round((hi + 4) / 0.27) + ' cm tall', input: 'height_cm' };
    },
    fold: function (rec, ans, F) {
      var fit = rec.fit, dims = [fit.folded_width_cm, fit.folded_depth_cm, fit.folded_height_cm].filter(Boolean).map(num);
      if (fit.foldable === true) return { q: 'Does it fold for the car boot?', ok: true, text: 'Folds' + (dims.length ? ' to ' + dims.join(' × ') + ' cm' : '') + (fit.product_weight_kg ? ' · ' + fit.product_weight_kg + ' kg' : ''), input: 'fold_need' };
      if (fit.foldable === false) return { q: 'Does it fold for the car boot?', ok: ans.fold_need === 'yes' ? false : 'warn', text: 'Does not fold', input: 'fold_need' };
      if (foldsByText((F.desc || '') + ' ' + rec.t)) return { q: 'Does it fold for the car boot?', ok: true, text: 'The description says it folds' + (dims.length ? ' (' + dims.join(' × ') + ' cm)' : ' — dimensions folded not published'), input: 'fold_need' };
      return { q: 'Does it fold for the car boot?', ok: 'unknown', text: NOTPUB, input: 'fold_need' };
    },
    liftWeight: function (rec, ans, F) {
      var pw = num(rec.fit.product_weight_kg);
      if (!pw) return { q: 'How heavy is it to lift?', ok: 'unknown', text: NOTPUB, input: 'lift_capacity' };
      var band = pw < 8 ? 'light' : pw <= 12 ? 'moderate' : 'heavy — two hands';
      if (ans.lift_capacity) { var c = CHECKS.liftCapacity(rec.fit, ans); return { q: 'Can I lift it into the car?', ok: c.ok, text: c.text + ' (' + band + ')', input: 'lift_capacity' }; }
      return { q: 'How heavy is it to lift?', ok: pw > 12 ? 'warn' : true, text: pw + ' kg — ' + band, input: 'lift_capacity' };
    },
    rated: function (rec, ans, F) {
      var max = num(rec.fit.max_user_weight_kg);
      if (ans.weight_kg) { var c = CHECKS.weight(rec.fit, ans); return { q: 'Is it rated for my weight?', ok: c.ok, text: c.text, input: 'weight_kg' }; }
      if (max) return { q: 'What weight is it rated to?', ok: true, text: 'Rated to ' + max + ' kg', input: 'weight_kg' };
      return { q: 'What weight is it rated to?', ok: 'unknown', text: NOTPUB, input: 'weight_kg' };
    },
    wheels: function (rec, ans, F) {
      var raw = (F.spec && F.spec.wheel_size) || descGrab(F, '\\d{2,3}\\s?(mm|cm|")\\s*(front |rear )?(wheel|castor|caster)') || descGrab(F, '(wheel|castor|caster)s?\\s*(size)?:?\\s*\\d{2,3}\\s?(mm|cm|")');
      if (!raw) return { q: 'Indoor or outdoor wheels?', ok: 'unknown', text: NOTPUB, input: 'where_used' };
      var m = raw.match(/(\d{2,3})\s?(mm|cm|")/), cm = m ? (m[2] === 'mm' ? +m[1] / 10 : m[2] === '"' ? +m[1] * 2.54 : +m[1]) : 0;
      var outdoors = cm >= 20;
      var ok = ans.where_used === 'out' || ans.where_used === 'both' ? (outdoors ? true : 'warn') : true;
      return { q: 'Indoor or outdoor wheels?', ok: ok, text: Math.round(cm) + ' cm wheels — ' + (outdoors ? 'fine outdoors and in shops' : 'best indoors and on smooth paths'), input: 'where_used' };
    },
    seatBrakes: function (rec, ans, F) {
      if (!/rollator|seat walker|walker/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var seat = /\bseat\b/i.test(rec.t + ' ' + (F.desc || '')), brakes = /brake/i.test(rec.t + ' ' + (F.desc || ''));
      if (!seat && !brakes) return { q: 'Does it have a seat and brakes?', ok: 'unknown', text: NOTPUB };
      return { q: 'Does it have a seat and brakes?', ok: seat && brakes ? true : 'warn', text: (seat ? 'Has a seat' : 'No seat mentioned') + ' · ' + (brakes ? (/loop|lockable|locking|parking/i.test(F.desc || '') ? 'lockable brakes' : 'brakes') : 'no brakes mentioned') };
    },
    tyres: function (rec, ans, F) {
      var p = descHas(F, 'pneumatic|air.?filled'), s = descHas(F, 'solid|puncture.?proof|pu tyre|flat.?free');
      if (!p && !s) return { q: 'Kerbs, grass or gravel?', ok: 'unknown', text: NOTPUB, input: 'terrain' };
      var rough = ans.terrain === 'rough';
      return { q: 'Kerbs, grass or gravel?', ok: rough && s && !p ? 'warn' : true, text: p ? 'Pneumatic (air) tyres — softer over kerbs and grass' : 'Solid, puncture-proof tyres — best on paths and indoors', input: 'terrain' };
    },
    turning: function (rec, ans, F) {
      var l = num(rec.fit.overall_length_cm);
      if (!l) return { q: 'How much space does it need to turn?', ok: 'unknown', text: NOTPUB };
      return { q: 'How much space does it need to turn?', ok: true, text: l + ' cm long; allow roughly ' + Math.round(l * 1.5) + ' cm to turn around' };
    },
    hip: function (rec, ans, F) {
      var lo = num(rec.fit.seat_width_min_cm) || num(rec.fit.seat_width_cm);
      if (ans.hip_cm) { var c = CHECKS.hip(rec.fit, ans); return { q: 'Is the seat wide enough for my hips?', ok: c.ok, text: c.text, input: 'hip_cm' }; }
      if (lo) return { q: 'Is the seat wide enough for my hips?', ok: true, text: 'Seat width ' + (num(rec.fit.seat_width_max_cm) && num(rec.fit.seat_width_max_cm) !== lo ? lo + '–' + rec.fit.seat_width_max_cm : lo) + ' cm; suits hips about ' + (lo - 5) + '–' + (lo - 2) + ' cm', input: 'hip_cm' };
      return { q: 'Is the seat wide enough for my hips?', ok: 'unknown', text: NOTPUB, input: 'hip_cm' };
    },
    propel: function (rec, ans, F) {
      var c = CHECKS.propel(rec.fit, { self_propel: ans.self_propel || 'carer' });
      if (rec.fit.self_propelled === undefined && rec.fit.powered === undefined) return { q: 'Self-propelled or pushed?', ok: 'unknown', text: NOTPUB, input: 'self_propel' };
      return { q: 'Self-propelled or pushed?', ok: c.ok, text: c.text, input: 'self_propel' };
    },
    recess: function (rec, ans, F) {
      var w = num(rec.fit.overall_width_cm), l = num(rec.fit.overall_length_cm);
      if (ans.recess_width_cm && (w || l)) { var c = CHECKS.recess(rec.fit, ans); return { q: 'Will it fit in my shower recess?', ok: c.ok, text: c.text, input: 'recess_width_cm' }; }
      if (w || l) return { q: 'Will it fit in my shower recess?', ok: true, text: (w ? w + ' cm wide' : '') + (w && l ? ' × ' : '') + (l ? l + ' cm deep' : '') + '; most recesses are 90 cm or more', input: 'recess_width_cm' };
      return { q: 'Will it fit in my shower recess?', ok: 'unknown', text: NOTPUB, input: 'recess_width_cm' };
    },
    bath: function (rec, ans, F) {
      if (!/bath/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var l = num(rec.fit.overall_length_cm) || num(rec.fit.overall_width_cm);
      if (ans.bath_width_cm && l) { var c = CHECKS.bath(rec.fit, ans); return { q: 'Will it fit over my bath?', ok: c.ok, text: c.text, input: 'bath_width_cm' }; }
      if (l) return { q: 'Will it fit over my bath?', ok: true, text: l + ' cm long; spans baths up to about ' + (l - 8) + ' cm inside', input: 'bath_width_cm' };
      return { q: 'Will it fit over my bath?', ok: 'unknown', text: NOTPUB, input: 'bath_width_cm' };
    },
    arms: function (rec, ans, F) {
      var t = rec.t + ' ' + (F.desc || '') + ' ' + optValues(rec).join(' ');
      var arms = /\barm(rest)?s?\b/i.test(t) && !/without arms|no arms/i.test(t), back = /\bback(rest)?\b/i.test(t) && !/without back|no back/i.test(t);
      if (!arms && !back) return { q: 'Can I get on and off safely alone?', ok: 'unknown', text: 'Armrests and backrest aren’t mentioned — we’ll confirm' };
      return { q: 'Can I get on and off safely alone?', ok: arms ? true : 'warn', text: (arms ? 'Has armrests to push up from' : 'No armrests mentioned') + (back ? ' · backrest' : '') };
    },
    wet: function (rec, ans, F) {
      var m = (F.spec && F.spec.material) || rec.mt || descGrab(F, 'aluminium|aluminum|stainless|rust.?(proof|free|resistant)|powder.?coated|plastic|polypropylene|abs\\b');
      if (!m) return { q: 'Does it suit a wet area?', ok: 'unknown', text: NOTPUB };
      var good = /alumin|stainless|rust|plastic|polyprop|abs|powder/i.test(m);
      return { q: 'Does it suit a wet area?', ok: good ? true : 'warn', text: m + (good ? ' — rust-free for wet areas' : ' — check it is rated for wet areas') };
    },
    overToilet: function (rec, ans, F) {
      if (!/commode|over.?toilet|surround|toilet frame/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var w = num(rec.fit.width_between_arms_cm);
      if (ans.toilet_width_cm && w) { var c = CHECKS.overToilet(rec.fit, ans); return { q: 'Will it fit over my toilet?', ok: c.ok, text: c.text, input: 'toilet_width_cm' }; }
      if (w) return { q: 'Will it fit over my toilet?', ok: true, text: w + ' cm between the legs; most toilets are 36–40 cm wide', input: 'toilet_width_cm' };
      return { q: 'Will it fit over my toilet?', ok: 'unknown', text: NOTPUB, input: 'toilet_width_cm' };
    },
    lift: function (rec, ans, F) {
      var lift = num(rec.fit.lift_cm);
      if (!lift) return { q: 'How much higher will it make the toilet?', ok: 'unknown', text: NOTPUB, input: 'lift_need' };
      if (ans.lift_need) { var c = CHECKS.lift(rec.fit, ans); return { q: 'How much higher will it make the toilet?', ok: c.ok, text: c.text, input: 'lift_need' }; }
      return { q: 'How much higher will it make the toilet?', ok: true, text: 'Adds ' + lift + ' cm', input: 'lift_need' };
    },
    liftHeight: function (rec, ans, F) {
      if (!ans.toilet_height_cm || !ans.height_cm) return { q: 'Is the lift right for my height?', ok: 'unknown', text: 'Add your toilet height and your height and we’ll work out the lift you need', input: 'toilet_height_cm' };
      var c = CHECKS.liftHeight(rec.fit, ans); return { q: 'Is the lift right for my height?', ok: c.ok, text: c.text, input: 'toilet_height_cm' };
    },
    toiletShape: function (rec, ans, F) {
      var s = sentence(F, 'elongated|round pan|standard pan|fits most|universal fit|standard toilet');
      return s ? { q: 'Will it fit my toilet?', ok: true, text: s } : { q: 'Will it fit my toilet (round or elongated)?', ok: 'unknown', text: NOTPUB };
    },
    lid: function (rec, ans, F) {
      if (/lid/i.test(rec.t + ' ' + (F.desc || ''))) return { q: 'Does it have a lid?', ok: true, text: /without lid|no lid/i.test(rec.t + ' ' + (F.desc || '')) ? 'Sold without a lid' : 'Comes with a lid' };
      return { q: 'Does it have a lid?', ok: 'unknown', text: NOTPUB };
    },
    removablePan: function (rec, ans, F) {
      if (!/commode/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var s = sentence(F, 'removable (pan|bucket|bowl)|pan (is )?removable|slide.?out pan');
      return s ? { q: 'Is the pan removable?', ok: true, text: s } : { q: 'Is the pan removable?', ok: 'unknown', text: NOTPUB };
    },
    mount: function (rec, ans, F) {
      if (!/rail|grab|bar|pole|handle/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var suction = descHas(F, 'suction|no drill|clamp'), s = sentence(F, 'tile|stud|plasterboard|masonry|fixings?|screws?');
      if (suction) return { q: 'Where can it mount?', ok: ans.mount_surface === 'suction' || !ans.mount_surface ? true : 'warn', text: 'No drilling — ' + (sentence(F, 'suction|no drill|clamp') || 'suction or clamp fixing'), input: 'mount_surface' };
      if (s) return { q: 'Where can it mount?', ok: ans.mount_surface === 'suction' ? 'warn' : true, text: s, input: 'mount_surface' };
      return { q: 'Where can it mount?', ok: 'unknown', text: 'Fixing details aren’t published — tell us the wall type and we’ll confirm', input: 'mount_surface' };
    },
    railLength: function (rec, ans, F) {
      if (!/rail|grab|bar/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var l = num(rec.fit.overall_length_cm);
      if (ans.rail_length_cm && l) { var c = CHECKS.railLength(rec.fit, ans); return { q: 'Is it the length I need?', ok: c.ok, text: c.text, input: 'rail_length_cm' }; }
      if (l) return { q: 'How long is it?', ok: true, text: l + ' cm long', input: 'rail_length_cm' };
      return { q: 'How long is it?', ok: 'unknown', text: NOTPUB, input: 'rail_length_cm' };
    },
    side: function (rec, ans, F) {
      var fs = String(rec.fit.fit_side || '').toLowerCase();
      if (ans.side && fs) { var c = CHECKS.side(rec.fit, ans); return { q: 'Left or right?', ok: c.ok, text: c.text, input: 'side' }; }
      if (fs) return { q: 'Left or right?', ok: true, text: fs === 'universal' ? 'Fits either side' : 'Made for the ' + fs, input: 'side' };
      var ov = optValues(rec).filter(function (v) { return /left|right/.test(v); });
      if (ov.length) return { q: 'Left or right?', ok: true, text: 'Choose the side when ordering: ' + ov.join(', '), input: 'side' };
      return { q: 'Left or right?', ok: 'unknown', text: NOTPUB, input: 'side' };
    },
    size: function (rec, ans, F) {
      var opts = sizeOptions(rec), guide = sentence(F, 'measure|circumference|to find your size|size guide');
      if (ans.size && opts.length) { var c = CHECKS.size(rec.fit, ans, rec); return { q: 'Which size am I?', ok: c.ok, text: c.text + (guide ? ' · ' + guide : ''), input: 'size' }; }
      if (opts.length) return { q: 'Which size am I?', ok: true, text: 'Sizes: ' + opts.join(', ') + (guide ? ' · ' + guide : ''), input: 'size' };
      return { q: 'Which size am I?', ok: 'unknown', text: NOTPUB, input: 'size' };
    },
    waist: function (rec, ans, F) {
      var opts = sizeOptions(rec);
      if (ans.waist_size && opts.length) { var c = CHECKS.waist(rec.fit, ans, rec); return { q: 'Which size do I need?', ok: c.ok, text: c.text, input: 'waist_size' }; }
      if (opts.length) return { q: 'Which size do I need?', ok: true, text: 'Sizes: ' + opts.join(', ') + (sentence(F, 'waist|hip') ? ' · ' + sentence(F, 'waist|hip') : ''), input: 'waist_size' };
      return { q: 'Which size do I need?', ok: 'unknown', text: NOTPUB, input: 'waist_size' };
    },
    absorb: function (rec, ans, F) {
      var t = rec.t + ' ' + (F.desc || ''), ml = t.match(/(\d{3,4})\s?ml/i);
      var lvl = /night|overnight|super plus|maxi plus|elite/i.test(t) ? 'night' : /heavy|maxi|super|extra|plus/i.test(t) ? 'heavy' : /moderate|medium|regular|normal/i.test(t) ? 'mod' : /light|liner|mini|ultra thin/i.test(t) ? 'light' : '';
      if (!lvl && !ml) return { q: 'How absorbent is it?', ok: 'unknown', text: NOTPUB, input: 'absorbency' };
      var lbl = { night: 'Night / extended', heavy: 'Heavy', mod: 'Moderate', light: 'Light' }[lvl] || 'Absorbency';
      var want = ans.absorbency, order = ['light', 'mod', 'heavy', 'night'];
      var ok = !want || !lvl ? true : order.indexOf(lvl) >= order.indexOf(want) ? true : 'warn';
      return { q: 'How absorbent is it?', ok: ok, text: lbl + (ml ? ' — about ' + ml[1] + ' ml' : '') + (ok === 'warn' ? '; you asked for ' + { light: 'light', mod: 'moderate', heavy: 'heavy', night: 'night' }[want] : ''), input: 'absorbency' };
    },
    dayNight: function (rec, ans, F) {
      var t = rec.t + ' ' + (F.desc || ''), n = /night|overnight/i.test(t), d = /day|daytime/i.test(t);
      if (!n && !d) return null;
      return { q: 'Day or night?', ok: ans.day_night === 'night' && !n ? 'warn' : true, text: n && d ? 'Day and night' : n ? 'Made for night use' : 'Made for daytime use', input: 'day_night' };
    },
    style: function (rec, ans, F) {
      var t = (rec.pt || '') + ' ' + rec.t, s = /pull.?up|pants/i.test(t) ? 'Pull-up pants' : /pad|insert|liner|guard/i.test(t) ? 'Pad or insert (worn in your own underwear or fixation pants)' : /slip|brief|nappy|nappies|tab/i.test(t) ? 'All-in-one brief with tabs' : '';
      return s ? { q: 'Pull-up, pad or brief?', ok: true, text: s } : null;
    },
    disposable: function (rec, ans, F) {
      var t = rec.t + ' ' + (F.desc || ''), w = /washable|reusable|machine wash/i.test(t), d = /disposable|single.?use/i.test(t);
      if (!w && !d) return { q: 'Washable or disposable?', ok: 'unknown', text: NOTPUB, input: 'disposable' };
      return { q: 'Washable or disposable?', ok: (ans.disposable === 'wash' && !w) || (ans.disposable === 'disp' && !d) ? 'warn' : true, text: w ? 'Washable and reusable' : 'Disposable', input: 'disposable' };
    },
    pack: function (rec, ans, F) {
      var t = rec.t + ' ' + optValues(rec).join(' '), m = t.match(/pack of (\d+)|(\d+)\s?(pack|pk|pcs|pieces|per (pack|box|carton))|x\s?(\d+)\b|(\d+)\s?(pairs?|units?)/i);
      if (!m) return { q: 'How many per pack?', ok: 'unknown', text: NOTPUB };
      return { q: 'How many per pack?', ok: true, text: m[0] };
    },
    washable: function (rec, ans, F) {
      var s = sentence(F, 'machine wash|hand wash|washable|wipe clean');
      return s ? { q: 'Can I wash it?', ok: true, text: s } : { q: 'Can I wash it?', ok: 'unknown', text: NOTPUB };
    },
    wearWhere: function (rec, ans, F) {
      var s = sentence(F, 'over clothing|under clothing|in water|in the shower|waterproof|neoprene');
      if (!s) return { q: 'Over clothing or in water?', ok: 'unknown', text: NOTPUB, input: 'wear_where' };
      return { q: 'Over clothing or in water?', ok: true, text: s, input: 'wear_where' };
    },
    purpose: function (rec, ans, F) {
      var s = sentence(F, 'support|compression|immobil|stabilis|pain');
      return s ? { q: 'What is it designed for?', ok: true, text: s, input: 'purpose' } : null;
    },
    oneHand: function (rec, ans, F) {
      var s = sentence(F, 'one.?hand|single.?hand');
      return s ? { q: 'Can I use it one-handed?', ok: true, text: s } : { q: 'Can I use it one-handed?', ok: 'unknown', text: NOTPUB, input: 'hand_strength' };
    },
    dishwasher: function (rec, ans, F) {
      if (!/kitchen|dining|cutlery|cup|plate|bowl|board|opener|knife|mug|eating|drinking|food/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var s = sentence(F, 'dishwasher');
      return s ? { q: 'Is it dishwasher safe?', ok: /not dishwasher|hand wash only/i.test(s) ? 'warn' : true, text: s } : { q: 'Is it dishwasher safe?', ok: 'unknown', text: NOTPUB };
    },
    reachLength: function (rec, ans, F) {
      if (!/reacher|grabber|pick.?up|long.?handled|sponge|shoe horn|sock/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var l = num(rec.fit.overall_length_cm) || (function () { var m = (rec.t + ' ' + (F.desc || '')).match(/(\d{2,3})\s?cm/); return m ? +m[1] : 0; })();
      if (ans.reach_need && l) { var c = CHECKS.reachLength({ overall_length_cm: l }, ans); return { q: 'How far does it reach?', ok: c.ok, text: c.text, input: 'reach_need' }; }
      if (l) return { q: 'How far does it reach?', ok: true, text: l + ' cm long', input: 'reach_need' };
      return { q: 'How far does it reach?', ok: 'unknown', text: NOTPUB, input: 'reach_need' };
    },
    itemWeight: function (rec, ans, F) {
      var pw = num(rec.fit.product_weight_kg), m = !pw && (F.desc || '').match(/weighs?\s*(?:just|only|around|about)?\s*(\d+(?:\.\d+)?)\s?(g|kg)\b/i);
      if (pw) return { q: 'How heavy is it?', ok: true, text: pw + ' kg' };
      if (m) return { q: 'How heavy is it?', ok: true, text: m[1] + ' ' + m[2] };
      return { q: 'How heavy is it?', ok: 'unknown', text: NOTPUB };
    },
    power: function (rec, ans, F) {
      if (rec.fit.powered === true) return { q: 'Does it need a power point?', ok: ans.power_point === 'no' ? 'warn' : true, text: ans.power_point === 'no' ? 'Needs mains power — plan an extension lead or a closer power point' : 'Needs mains power', input: 'power_point' };
      if (rec.fit.powered === false) return { q: 'Does it need a power point?', ok: true, text: 'No power needed' };
      if (descHas(F, 'mains|power point|plug in|240 ?v|battery|rechargeable')) return { q: 'Does it need a power point?', ok: true, text: sentence(F, 'mains|power point|plug in|240 ?v|battery|rechargeable') };
      return { q: 'Does it need a power point?', ok: 'unknown', text: NOTPUB, input: 'power_point' };
    },
    powerSource: function (rec, ans, F) {
      var s = sentence(F, 'battery|batteries|rechargeable|mains|usb');
      if (rec.fit.powered === true) return { q: 'Battery or mains?', ok: ans.power_source === 'battery' ? 'warn' : true, text: 'Mains powered', input: 'power_source' };
      if (rec.fit.powered === false || s) return { q: 'Battery or mains?', ok: true, text: s || 'Battery powered', input: 'power_source' };
      return { q: 'Battery or mains?', ok: 'unknown', text: NOTPUB, input: 'power_source' };
    },
    app: function (rec, ans, F) {
      var s = sentence(F, 'bluetooth|\\bapp\\b|smartphone|wi-?fi');
      if (s) return { q: 'Does it connect to a phone?', ok: true, text: s, input: 'app_need' };
      return { q: 'Does it connect to a phone?', ok: ans.app_need === 'yes' ? 'warn' : 'unknown', text: ans.app_need === 'yes' ? 'No phone or app connection is mentioned — we’ll confirm' : NOTPUB, input: 'app_need' };
    },
    cuff: function (rec, ans, F) {
      if (!/blood pressure|bp monitor|sphyg/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var c = ans.cuff_cm ? CHECKS.cuff(rec.fit, ans, rec) : null;
      if (c) return { q: 'Will the cuff fit my arm?', ok: c.ok, text: c.text, input: 'cuff_cm' };
      var s = sentence(F, 'cuff');
      return s ? { q: 'Will the cuff fit my arm?', ok: true, text: s, input: 'cuff_cm' } : { q: 'Will the cuff fit my arm?', ok: 'unknown', text: NOTPUB, input: 'cuff_cm' };
    },
    alertWho: function (rec, ans, F) {
      var s = sentence(F, 'pager|receiver|carer|smartphone|app|monitoring (centre|service)|call centre');
      return s ? { q: 'Who gets the alert?', ok: true, text: s, input: 'alert_who' } : { q: 'Who gets the alert?', ok: 'unknown', text: NOTPUB, input: 'alert_who' };
    },
    range: function (rec, ans, F) {
      var m = (F.desc || '').match(/(\d{2,4})\s?(m|metres|meters|km)\b[^.]*(range|distance)|range[^.]*?(\d{2,4})\s?(m|metres|meters|km)\b/i);
      if (!m) return { q: 'What range does it have?', ok: 'unknown', text: NOTPUB, input: 'range_need' };
      return { q: 'What range does it have?', ok: true, text: m[0], input: 'range_need' };
    },
    cushionGrade: function (rec, ans, F) {
      if (!/cushion|mattress|overlay|pressure/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var t = rec.t + ' ' + (F.desc || ''), g = /very high risk|alternating|dynamic/i.test(t) ? 'high' : /high risk/i.test(t) ? 'high' : /medium risk|gel|visco|memory/i.test(t) ? 'med' : /low risk|comfort|foam/i.test(t) ? 'low' : '';
      if (!g) return { q: 'What pressure-injury risk level is it for?', ok: 'unknown', text: NOTPUB, input: 'risk' };
      var order = ['low', 'med', 'high'], want = ans.risk;
      return { q: 'What pressure-injury risk level is it for?', ok: want && order.indexOf(g) < order.indexOf(want) ? 'warn' : true, text: ({ low: 'Low risk — comfort', med: 'Medium risk', high: 'High risk' })[g] + (want && order.indexOf(g) < order.indexOf(want) ? '; you need a higher grade' : ''), input: 'risk' };
    },
    chairFit: function (rec, ans, F) {
      if (!/cushion|overlay|pad/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      var w = num(rec.fit.seat_width_cm) || num(rec.fit.overall_width_cm), d = num(rec.fit.seat_depth_cm) || num(rec.fit.overall_length_cm);
      if (ans.chair_seat_width_cm && w) { var c = CHECKS.chairFit(rec.fit, ans); return { q: 'Will it fit the chair I have?', ok: c.ok, text: c.text + (d ? ' · ' + d + ' cm deep' : ''), input: 'chair_seat_width_cm' }; }
      if (w) return { q: 'Will it fit the chair I have?', ok: true, text: w + ' cm wide' + (d ? ' × ' + d + ' cm deep' : ''), input: 'chair_seat_width_cm' };
      return { q: 'Will it fit the chair I have?', ok: 'unknown', text: NOTPUB, input: 'chair_seat_width_cm' };
    },
    bedFit: function (rec, ans, F) {
      var w = num(rec.fit.bed_width_cm), l = num(rec.fit.bed_length_cm);
      if (ans.bed_size && w) { var c = CHECKS.bed(rec.fit, ans); return { q: 'Will it fit my bed?', ok: c.ok, text: c.text + (l ? ' × ' + l + ' cm long' : ''), input: 'bed_size' }; }
      if (w) return { q: 'What size is it?', ok: true, text: w + ' cm wide' + (l ? ' × ' + l + ' cm long' : ''), input: 'bed_size' };
      var opts = sizeOptions(rec);
      if (opts.length) return { q: 'What size is it?', ok: true, text: 'Sizes: ' + opts.join(', '), input: 'bed_size' };
      return { q: 'What size is it?', ok: 'unknown', text: NOTPUB, input: 'bed_size' };
    },
    frameFit: function (rec, ans, F) {
      if (!/overlay|sheet|protector|topper|cover|cradle/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      if (ans.frame_size) { var c = CHECKS.frameFit(rec.fit, ans, rec); return { q: 'Does it fit my existing bed?', ok: c.ok, text: c.text, input: 'frame_size' }; }
      var opts = sizeOptions(rec);
      return opts.length || rec.fit.bed_width_cm ? { q: 'Does it fit my existing bed?', ok: true, text: rec.fit.bed_width_cm ? rec.fit.bed_width_cm + ' cm wide' : 'Sizes: ' + opts.join(', '), input: 'frame_size' } : { q: 'Does it fit my existing bed?', ok: 'unknown', text: NOTPUB, input: 'frame_size' };
    },
    bedHeight: function (rec, ans, F) {
      if (!/\bbed\b|beds/i.test((rec.pt || '') + ' ' + rec.t) || /mattress|overlay|sheet|rail|cradle|table/i.test(rec.t)) return null;
      var lo = num(rec.fit.seat_height_min_cm), hi = num(rec.fit.seat_height_max_cm);
      if (lo && hi) return { q: 'What height range does it have?', ok: true, text: 'Adjusts ' + lo + '–' + hi + ' cm' };
      var s = sentence(F, 'height (range|adjust)|hi.?lo|adjusts? from');
      return s ? { q: 'What height range does it have?', ok: true, text: s } : { q: 'What height range does it have?', ok: 'unknown', text: NOTPUB };
    },
    hoistClear: function (rec, ans, F) {
      var m = (F.desc || '').match(/(\d{1,2}(?:\.\d)?)\s?cm[^.]*(clearance|under.?bed)|(clearance|under.?bed)[^.]*?(\d{1,2}(?:\.\d)?)\s?cm/i);
      if (!m) return { q: 'Will a hoist fit underneath?', ok: 'unknown', text: NOTPUB };
      return { q: 'Will a hoist fit underneath?', ok: true, text: m[0] };
    },
    slingSize: function (rec, ans, F) {
      if (!/sling|belt|vest/i.test((rec.pt || '') + ' ' + rec.t)) return null;
      if (ans.chest_cm) { var c = CHECKS.chest(rec.fit, ans, rec); return { q: 'Which sling size?', ok: c.ok, text: c.text, input: 'chest_cm' }; }
      var opts = sizeOptions(rec);
      return opts.length ? { q: 'Which sling size?', ok: true, text: 'Sizes: ' + opts.join(', ') + ' — add a chest measurement and we’ll pick one', input: 'chest_cm' } : { q: 'Which sling size?', ok: 'unknown', text: NOTPUB, input: 'chest_cm' };
    },
    canStand: function (rec, ans, F) {
      var t = rec.t + ' ' + (F.desc || ''), standing = /stand(ing)? (aid|hoist|lifter)|sit.?to.?stand|weight.?bear/i.test(t), full = /full (body )?sling|non.?weight.?bearing|hoist/i.test(t);
      if (!standing && !full) return null;
      var ok = ans.can_stand === 'no' && standing && !full ? false : ans.can_stand === 'yes' && full && !standing ? 'warn' : true;
      return { q: 'Does the person need to stand with help?', ok: ok, text: standing ? 'Made for people who can bear some weight and stand with help' : 'Suits people who cannot stand (assisted transfer)', input: 'can_stand' };
    },
    carer: function (rec, ans, F) {
      var s = sentence(F, 'carer|attendant|two.?person|one.?person');
      return s ? { q: 'Does it need a carer?', ok: true, text: s } : { q: 'Does it need a carer?', ok: 'unknown', text: NOTPUB };
    },
    quantity: function (rec, ans, F) {
      var ov = optValues(rec).filter(function (v) { return /carton|box|pack|bulk|each/.test(v); });
      return ov.length ? { q: 'Can I buy in bulk?', ok: true, text: 'Sold as: ' + ov.join(', '), input: 'quantity' } : null;
    }
  };
  function sizeOptions(rec) {
    var fit = rec.fit || {};
    if (fit.size_options) return String(fit.size_options).split(/\s*,\s*/).filter(Boolean);
    var op = rec.op || {}, out = [];
    Object.keys(op).forEach(function (k) { if (/size|waist|width/i.test(k)) out = out.concat(op[k] || []); });
    return out;
  }
  function runChecks(rec, ans, qids) {
    var fit = rec.fit || {}, out = [];
    (qids || Object.keys(CHECKS)).forEach(function (id) {
      var fn = CHECKS[id]; if (!fn) return;
      var r = fn(fit, ans, rec); if (!r) return;
      (Array.isArray(r) ? r : [r]).forEach(function (c) { if (c) out.push(c); });
    });
    return out;
  }
  function verdictOf(checks) {
    if (checks.some(function (c) { return c.ok === false; })) return 'no';
    if (checks.some(function (c) { return c.ok === 'warn'; })) return 'maybe';
    return checks.length ? 'yes' : 'none';
  }
  /* small badge for product cards in collection mode (only from saved numbers) */
  function fitBadge(rec) {
    var m = Mem.get();
    if (!m.weight_kg && !m.height_cm && !m.doorway_cm) return '';
    if (!rec.fit || !Object.keys(rec.fit).length) return '';
    var v = verdictOf(runChecks(rec, m, ['weight', 'height', 'width']).filter(function (c) { return c.ok !== 'warn' || !/isn.t published|aren.t published/.test(c.text); }));
    if (v === 'yes') return '<span class="hmc-fit hmc-fit--ok" title="Checked against your saved height, weight and doorway">✓ Fits your details</span>';
    if (v === 'maybe') return '<span class="hmc-fit hmc-fit--warn">! Check fit</span>';
    if (v === 'no') return '<span class="hmc-fit hmc-fit--no">✗ Not your size</span>';
    return '';
  }
  function badgeGrid(grid, lookup) {
    if (!grid || !Mem.hasNumbers()) return;
    Array.prototype.forEach.call(grid.querySelectorAll('.card:not([data-hmc-badged])'), function (card) {
      card.setAttribute('data-hmc-badged', '1');
      var a = card.querySelector('a[href*="/products/"]'); if (!a) return;
      var h = (a.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1];
      var rec = h && lookup(h); if (!rec) return;
      var b = fitBadge(rec); if (!b) return;
      var body = card.querySelector('.card__body'); if (body) body.insertAdjacentHTML('afterbegin', b);
    });
  }

  /* =========================================================================
     4. Shared UI bits
     ========================================================================= */
  function trapFocus(el) {
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(el.querySelectorAll('button:not([disabled]),[href],input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  function lockScroll(on) { document.documentElement.classList.toggle('hmc-lock', on); }
  function smoothTo(top) { window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' }); }
  function optionCard(q, o, on, count, extra) {
    return '<button type="button" class="hmc-opt' + (on ? ' is-on' : '') + '" role="' + (q.multi ? 'checkbox' : 'radio') + '" aria-checked="' + on + '" data-q="' + q.id + '" data-o="' + o.id + '"' + (extra || '') + '>' +
      '<span class="hmc-opt__box" aria-hidden="true"></span><span class="hmc-opt__t"><b>' + esc(o.label) + '</b>' + (o.sub ? '<small>' + esc(o.sub) + '</small>' : '') + '</span>' +
      (count !== undefined && count !== null ? '<span class="hmc-opt__n">' + count + '</span>' : '') + '</button>';
  }
  function stepperHTML(q, val) {
    var v = val == null ? '' : val;
    return '<div class="hmc-num" data-num="' + q.id + '">' +
      '<button type="button" class="hmc-num__b" data-step="-1" aria-label="Less">−</button>' +
      '<label class="hmc-num__f"><input type="number" inputmode="numeric" min="' + q.min + '" max="' + q.max + '" step="' + q.step + '" value="' + esc(v) + '" placeholder="' + q.default + '" data-q="' + q.id + '" aria-label="' + esc(q.title) + ' in ' + q.unit + '"><span>' + q.unit + '</span></label>' +
      '<button type="button" class="hmc-num__b" data-step="1" aria-label="More">+</button>' +
      '<input type="range" min="' + q.min + '" max="' + q.max + '" step="' + q.step + '" value="' + (v === '' ? q.default : v) + '" data-range="' + q.id + '" aria-label="' + esc(q.title) + ' slider">' +
      '<button type="button" class="hmc-num__skip" data-notsure="' + q.id + '"' + (v === '' ? ' aria-pressed="true"' : '') + '>Not sure</button></div>';
  }

  /* "Haven't found your product? Search our entire range" — runs CWIndex.search over /collections/all */
  function RangeBlock(el) {
    if (!el) return null;
    var input = el.querySelector('[data-hmc-range-q]'), grid = el.querySelector('[data-hmc-range-grid]'), note = el.querySelector('[data-hmc-range-note]'), more = el.querySelector('[data-hmc-range-more]');
    var all = null, list = [], shown = 0, PAGE = 12, timer;
    function ensure() { return all ? Promise.resolve(all) : X.load('/collections/all').then(function (l) { all = l; return l; }); }
    function render() {
      var h = '';
      list.slice(shown, shown + PAGE).forEach(function (it) { h += X.card(it); });
      grid.insertAdjacentHTML('beforeend', h);
      shown = Math.min(list.length, shown + PAGE);
      more.hidden = shown >= list.length;
      more.textContent = 'More (' + (list.length - shown) + ' left)';
      document.dispatchEvent(new CustomEvent('hmc:cards', { detail: { grid: grid } }));
    }
    function run(q, msg) {
      q = (q || '').trim();
      grid.innerHTML = ''; shown = 0; list = [];
      if (!q) { note.textContent = ''; more.hidden = true; el.classList.remove('is-busy'); return; }
      el.classList.add('is-busy');
      ensure().then(function (items) {
        var r = X.searchFuzzy(items, q);
        list = r.items;
        note.innerHTML = (msg ? esc(msg) + ' ' : '') + (list.length ? '<b>' + list.length + '</b> product' + (list.length === 1 ? '' : 's') + ' across our whole range' + (r.corrected ? ' for “' + esc(r.corrected) + '”' : '') : 'Nothing in our range mentions “' + esc(q) + '”. Try another word, or <a href="/pages/contact">ask us</a>.');
        el.classList.remove('is-busy');
        render();
      }).catch(function () { el.classList.remove('is-busy'); note.textContent = 'Search is unavailable right now.'; });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { run(input.value); }, 200); });
    input.closest('form').addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); run(input.value); input.blur(); });
    more.addEventListener('click', render);
    return { run: function (q, msg) { input.value = q || ''; run(q, msg); }, el: el, lookup: function (h) { return all && all.filter(function (it) { return it.h === h; })[0]; } };
  }

  /* =========================================================================
     4b. Result-screen actions shared by both modes (v33 result update):
         verdict gating, "source it" button, the quote basket (window.AWQuote, assets/aw-quote.js) and its
         micro-prompt, a direct AJAX add (collection results) that reuses window.CWCart for the count bump.
     ========================================================================= */
  var VLABEL = { yes: 'Good fit', maybe: 'Likely fit', none: 'Unsure', no: 'Not a good fit' };
  var VICON = { yes: '✓', maybe: '!', none: '?', no: '✗' };
  function canBuy(v) { return v !== 'no'; } // Good fit / Likely fit / Unsure → Add to cart; Not a good fit → source it
  function srcBtnHTML(attrs, extraCls) {
    return '<button type="button" class="fit-src' + (extraCls ? ' ' + extraCls : '') + '" ' + attrs + '><span class="fit-src__t">Nothing suitable? <b>We’ll try to source it</b></span><span class="fit-src__go" aria-hidden="true">→</span></button>';
  }
  /* window.AWQuote exists only after aw-quote.js runs (DOMContentLoaded): wait for it, up to 6 s */
  function awq() {
    return new Promise(function (res, rej) {
      var n = 0; (function poll() { if (window.AWQuote && window.AWQuote.add) return res(window.AWQuote); if (++n > 60) return rej(new Error('quote unavailable')); setTimeout(poll, 100); })();
    });
  }
  /* add one product + variant to the existing multi-item quote basket, exactly as the product page does */
  function quoteAdd(handle, variantId, qty) {
    return awq().then(function (Q) {
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (prod) {
        var v = prod.variants.filter(function (x) { return x.id === +variantId; })[0] || prod.variants[0];
        var im = (v.featured_image && v.featured_image.src) || prod.featured_image || '';
        if (im && im.indexOf('//') === 0) im = 'https:' + im;
        Q.add({ id: v.id, title: prod.title, variant: v.title === 'Default Title' ? '' : v.title, price: v.price, img: im, url: '/products/' + prod.handle + '?variant=' + v.id, qty: Math.max(1, qty || 1) });
        return { prod: prod, v: v };
      });
    });
  }
  function quotePrompt(el, title) {
    if (!el) return;
    el.innerHTML = '<div class="fit-qp__card" role="status" aria-live="polite">' +
      '<p class="fit-qp__t"><span class="fit-qp__tick" aria-hidden="true">✓</span>Added to your quote</p>' +
      '<p class="fit-qp__s">' + esc(title) + ' is in your quote list. Add anything else you need, then send it — we’ll reply with a firm price, usually within one business day.</p>' +
      '<div class="fit-qp__btns"><button type="button" class="fit-qp__ghost" data-qp-close>Add something else</button><a class="fit-qp__go" href="/pages/quote">Send my quote request <span aria-hidden="true">→</span></a></div></div>';
    el.hidden = false;
    var go = el.querySelector('.fit-qp__go'); if (go) setTimeout(function () { go.focus({ preventScroll: true }); }, 30);
    el.onclick = function (e) { if (e.target.closest('[data-qp-close]')) { el.hidden = true; el.innerHTML = ''; } };
  }
  /* AJAX add for result screens without a product form; same request shape as the guides (sections → CWCart) */
  function directAdd(variantId, qty) {
    var C = window.CWCart, payload = { items: [{ id: +variantId, quantity: Math.max(1, qty || 1) }] };
    if (C && C.sections) payload.sections = C.sections();
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Sorry, that could not be added.');
        if (C && C.apply && res.j.sections) return C.apply(res.j.sections).catch(function () {}).then(function () { return res.j; });
        return res.j;
      });
  }
  var prodCache = {};
  function productJS(handle) { return prodCache[handle] || (prodCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })); }
  function stepHTML(attr, n, label) {
    return '<span class="fit-qty" role="group" aria-label="' + (label || 'Quantity') + '"><button type="button" ' + attr + '="-1" aria-label="One fewer">−</button><span class="fit-qty__n" aria-live="polite">' + n + '</span><button type="button" ' + attr + '="1" aria-label="One more">+</button></span>';
  }

  /* =========================================================================
     5. COLLECTION MODE — the chooser
     ========================================================================= */
  function collectionMode(root) {
    var cat = document.querySelector('[data-catalog]'), C = window.CWCatalog;
    var panel = root.querySelector('[data-hmc-panel]'), backdrop = root.querySelector('[data-hmc-backdrop]');
    var body = panel.querySelector('[data-hmc-body]'), foot = panel.querySelector('[data-hmc-foot]'), prog = panel.querySelector('[data-hmc-progress]');
    var side = cat && cat.querySelector('.cat__side-scroll');
    var strip = document.querySelector('[data-hmc-strip]');
    var range = RangeBlock(document.querySelector('[data-hmc-range]'));
    var ctx = { handle: root.dataset.handle || '', tags: (root.dataset.tags || '').split(',').filter(Boolean), title: root.dataset.title || '' };
    var cfg = null, fam = null, Q = [], answers = {}, cur = 0, items = [], all = null, open = false, lastFocus = null, widened = false, autoFrom = {};
    var collectionIds = {};

    function esc_(s) { return esc(s); }
    function qById(id) { return Q.filter(function (q) { return q.id === id; })[0]; }
    function answered(q) { var a = answers[q.id]; return q.text ? !!(a && a.trim()) : !!(a && a.length); }
    function nAnswered() { return Q.filter(answered).length; }

    /* --- scoring --- */
    function textPred(q) {
      var raw = answers[q.id]; if (!raw || !window.AWUnderstand) return null;
      var parsed = window.AWUnderstand.parse(raw);
      return { parsed: parsed, test: function (it) { if (!window.AWUnderstand.passes(it, parsed, { noBudget: true })) return false; return parsed.q ? X.search([it], parsed.q).length > 0 : true; } };
    }
    var textCache = {};
    function qPasses(q, it) {
      // true / false / null(unknown) for one answered question
      if (q.text) { var tp = textCache[q.id] || (textCache[q.id] = textPred(q)); return tp ? tp.test(it) : null; }
      var sel = answers[q.id] || [], sawNull = false;
      for (var i = 0; i < sel.length; i++) {
        var o = q.options.filter(function (x) { return x.id === sel[i]; })[0]; if (!o) continue;
        var v = evalRule(o.test, it);
        if (v === true) return true; if (v === null) sawNull = true;
      }
      return sawNull ? null : false;
    }
    function score(it) {
      // returns null when excluded, else a rank score (higher is better)
      var s = 0;
      for (var i = 0; i < Q.length; i++) {
        var q = Q[i]; if (!answered(q)) continue;
        var v = qPasses(q, it);
        if (v === true) s += q.soft ? 1 : 2;
        else if (v === false) { if (!q.soft) return null; s -= 1; }
      }
      s += it.a ? 0.5 : 0;
      s += (it.tg || []).indexOf('no-sale') > -1 ? 0 : 0.25;
      s += Math.min(0.2, (it.d || 0) / 1e11); // newest: a very small tie-breaker
      return s;
    }
    function rank(pool) {
      var out = [];
      pool.forEach(function (it, i) { var s = score(it); if (s !== null) out.push({ it: it, s: s, i: i }); });
      out.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
      return out.map(function (o) { return o.it; });
    }
    function countFor(q, o) {
      // live count: products passing every other answered question plus this option
      var pool = items, n = 0;
      pool.forEach(function (it) {
        for (var i = 0; i < Q.length; i++) { var x = Q[i]; if (x === q || !answered(x) || x.soft) continue; if (qPasses(x, it) === false) return; }
        if (evalRule(o.test, it) !== false) n++;
      });
      return n;
    }
    function matches() { textCache = {}; return rank(items); }

    /* --- memory pre-fill (weight / height questions answered from saved details) --- */
    function prefill() {
      var m = Mem.get();
      Q.forEach(function (q) {
        if (answers[q.id] && answers[q.id].length) return;
        if (q.weight && m.weight_kg) { answers[q.id] = [m.weight_kg <= 120 ? 'w120' : m.weight_kg <= 160 ? 'w160' : 'w200']; autoFrom[q.id] = m.weight_kg + ' kg'; }
        if (q.height && m.height_cm) { answers[q.id] = [m.height_cm < 160 ? 'h1' : m.height_cm <= 180 ? 'h2' : 'h3']; autoFrom[q.id] = m.height_cm + ' cm'; }
      });
    }

    /* --- rendering --- */
    function render() {
      if (!Q.length) return;
      if (enqMode) { enqMode = false; if (enq) enq.hidden = true; body.hidden = false; prog.hidden = false; }
      cur = Math.max(0, Math.min(Q.length - 1, cur));
      var q = Q[cur], h = '';
      prog.innerHTML = Q.map(function (x, i) {
        var a = answered(x), lbl = a ? (x.text ? '“' + esc(String(answers[x.id]).slice(0, 18)) + '”' : (answers[x.id].map(function (id) { var o = x.options.filter(function (y) { return y.id === id; })[0]; return o ? o.label : id; }).join(', '))) : x.title;
        return '<button type="button" class="hmc-chip' + (i === cur ? ' is-cur' : '') + (a ? ' is-done' : '') + '" data-go="' + i + '" aria-current="' + (i === cur ? 'step' : 'false') + '"><i>' + (a ? '✓' : i + 1) + '</i>' + esc(lbl) + '</button>';
      }).join('');
      h += '<div class="hmc-q" role="group" aria-labelledby="hmc-q-title"><p class="hmc-q__t" id="hmc-q-title">' + esc(q.title) + (q.multi ? ' <small>pick any</small>' : '') + '</p>' + (q.hint ? '<p class="hmc-q__h">' + esc(q.hint) + '</p>' : '');
      if (autoFrom[q.id]) h += '<p class="hmc-auto">Using your saved details (' + esc(autoFrom[q.id]) + ') · <button type="button" class="hmc-link" data-edit-auto="' + q.id + '">edit</button></p>';
      if (q.text) {
        h += '<form class="hmc-text" data-text-form><input type="text" data-text="' + q.id + '" value="' + esc(answers[q.id] || '') + '" placeholder="e.g. can’t get up off the toilet, under $200" autocomplete="off" aria-label="' + esc(q.title) + '"><button type="submit" class="btn btn--navy btn--sm">Go</button></form>' +
          '<div class="hmc-try">' + ['Mum can’t get up off the toilet', 'Unsteady walking to the shops', 'Pain in my knee when I walk', 'Something to hold onto in the shower'].map(function (t) { return '<button type="button" class="hmc-try__b" data-try="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div>';
        var tp = textCache[q.id] || (textCache[q.id] = textPred(q));
        if (tp && tp.parsed.picked.length) h += '<p class="hmc-q__h">We picked: <b>' + tp.parsed.picked.map(esc).join('</b> · <b>') + '</b>' + (tp.parsed.q ? ' · matching “' + esc(tp.parsed.q) + '”' : '') + '</p>';
      } else {
        h += '<div class="hmc-opts" role="' + (q.multi ? 'group' : 'radiogroup') + '">';
        q.options.forEach(function (o) {
          var n = countFor(q, o), on = (answers[q.id] || []).indexOf(o.id) > -1;
          h += optionCard(q, o, on, n, n === 0 && !on ? ' data-zero="1"' : '');
        });
        h += '</div>';
      }
      h += '</div>';
      h += '<div class="hmc-nav">' + (cur > 0 ? '<button type="button" class="hmc-link" data-prev>← Back</button>' : '<span></span>') +
        (cur < Q.length - 1 ? '<button type="button" class="hmc-link hmc-link--skip" data-skip>Skip →</button>' : '') + '</div>';
      body.innerHTML = h;
      renderFoot();
    }
    function renderFoot() {
      var n = nAnswered();
      var res = n ? matches() : items;
      widened = false;
      var h = '';
      if (n && !res.length) {
        widened = true;
        h += '<p class="hmc-foot__msg">Nothing in this collection matches — we’ll widen it to our whole range.</p>';
        h += '<button type="button" class="btn btn--red btn--block hmc-apply" data-apply>Show closest matches</button>';
      } else {
        h += '<button type="button" class="btn btn--red btn--block hmc-apply" data-apply' + (!n ? ' disabled' : '') + '>Show ' + res.length + ' product' + (res.length === 1 ? '' : 's') + '</button>';
      }
      h += '<div class="hmc-foot__row"><button type="button" class="hmc-link" data-restart' + (!n ? ' hidden' : '') + '>Start over</button><button type="button" class="hmc-link" data-close-panel>Close</button></div>';
      foot.innerHTML = h;
    }

    /* --- placement: desktop = sidebar panel, <990 = bottom sheet --- */
    function place() {
      if (!open) return;
      if (DESK()) {
        if (panel.parentNode !== side && side) side.appendChild(panel);
        root.classList.remove('is-sheet'); root.classList.add('is-side');
        if (cat) cat.classList.add('is-hmc-open');
        lockScroll(false);
      } else {
        if (panel.parentNode !== root) root.appendChild(panel);
        root.classList.remove('is-side'); root.classList.add('is-sheet');
        if (cat) cat.classList.remove('is-hmc-open');
        lockScroll(true);
      }
    }
    function openPanel(on) {
      open = on;
      rbarShow(!on && !!R.list);
      if (!on && enqMode) showEnq(false);
      root.classList.toggle('is-open', on);
      panel.classList.toggle('is-open', on); // the panel moves into the sidebar on desktop, so it carries its own state
      if (on) {
        lastFocus = document.activeElement;
        if (C && cat && cat.classList.contains('is-sheet-open')) C.openSheet(false); // close the filter drawer first
        place();
        if (!Q.length) body.innerHTML = '<p class="hmc-q__h">Loading questions…</p>';
        panel.setAttribute('aria-hidden', 'false');
        var first = panel.querySelector('[data-hmc-close]'); if (first) first.focus({ preventScroll: true });
        if (DESK() && cat) { var top = cat.getBoundingClientRect().top + window.scrollY - headerH() - 8; if (window.scrollY > top) smoothTo(top); }
      } else {
        root.classList.remove('is-sheet', 'is-side');
        if (cat) cat.classList.remove('is-hmc-open');
        lockScroll(false);
        panel.setAttribute('aria-hidden', 'true');
        if (panel.parentNode !== root) root.appendChild(panel);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
    }

    /* --- URL state: ?hmc=where.shower,help.sit+hold,text.<words> --- */
    function writeURL() {
      var u = new URL(location.href);
      var parts = Q.filter(answered).map(function (q) { return q.id + '.' + (q.text ? encodeURIComponent(answers[q.id]) : answers[q.id].join('+')); });
      if (parts.length) u.searchParams.set('hmc', parts.join(',')); else u.searchParams.delete('hmc');
      history.pushState({ hmc: parts.join(',') }, '', u.pathname + u.search + u.hash);
    }
    function readURL() {
      var v = new URL(location.href).searchParams.get('hmc'); answers = {}; autoFrom = {};
      if (!v) return false;
      v.split(',').forEach(function (p) {
        var i = p.indexOf('.'); if (i < 0) return;
        var id = p.slice(0, i), val = p.slice(i + 1), q = qById(id); if (!q) return;
        answers[id] = q.text ? decodeURIComponent(val) : val.split('+').filter(function (o) { return q.options.some(function (x) { return x.id === o; }); });
      });
      return nAnswered() > 0;
    }

    /* --- apply to the grid --- */
    function allIndex() { return all ? Promise.resolve(all) : X.load('/collections/all').then(function (l) { all = l; return l; }); }
    function apply(opts) {
      opts = opts || {};
      if (!C) return;
      var n = nAnswered(), res = matches();
      var finish = function (list, wide) {
        C.applyPicks(list, n, { widened: wide, scroll: !opts.silent, silent: true });
        if (!opts.silent) writeURL();
        renderStrip(list, wide);
        showResultsBar(list, wide);
      };
      if (!res.length) {
        allIndex().then(function (list) { textCache = {}; finish(rank(list), true); }).catch(function () { finish([], true); });
      } else finish(res, false);
      openPanel(false);
    }
    function renderStrip(list, wide) {
      if (!strip) return;
      if (wide || !nAnswered()) { strip.hidden = true; return; }
      allIndex().then(function (allItems) {
        textCache = {};
        var ids = {}; list.forEach(function (it) { ids[it.i] = 1; });
        var extra = rank(allItems.filter(function (it) { return !ids[it.i] && !collectionIds[it.i]; })).slice(0, 6);
        strip.hidden = !extra.length;
        var g = strip.querySelector('[data-hmc-strip-grid]');
        if (g) { g.innerHTML = extra.map(function (it) { return X.card(it); }).join(''); document.dispatchEvent(new CustomEvent('hmc:cards', { detail: { grid: g } })); }
      }).catch(function () { strip.hidden = true; });
    }
    function reset(silent) { R.list = null; R.top = null; rbarShow(false); answers = {}; autoFrom = {}; textCache = {}; cur = 0; if (strip) strip.hidden = true; if (!silent) { var u = new URL(location.href); if (u.searchParams.has('hmc')) { u.searchParams.delete('hmc'); history.pushState({ hmc: '' }, '', u.pathname + u.search + u.hash); } } if (open) render(); }

    /* --- results bar (v33 result update): top match with Add to cart, Add to quote and Re-check; when nothing in the
       collection matched (results widened to the whole range) or every match is "not your size", the "source it"
       button replaces Add to cart. Hidden while the chooser is open; cleared with the answers. --- */
    var rbar = root.querySelector('[data-hmc-rbar]'), rin = rbar && rbar.querySelector('[data-hmc-rbar-in]'), rqp = rbar && rbar.querySelector('[data-hmc-qp]');
    var enq = panel.querySelector('[data-hmc-enquiry]'), enqMode = false;
    var R = { list: null, wide: false, top: null, prod: null, vid: null, qty: 1, on: false };
    var memberPct = (window.CW && +window.CW.memberPct) || 10, isMember = !!(window.CW && window.CW.member);
    function ansSummary() {
      return Q.filter(answered).map(function (q) {
        return q.title + ': ' + (q.text ? answers[q.id] : answers[q.id].map(function (id) { var o = q.options.filter(function (y) { return y.id === id; })[0]; return o ? o.label : id; }).join(', '));
      }).join('; ');
    }
    function rbarPad() { var h = R.on && rbar ? rbar.offsetHeight : 0; document.body.style.paddingBottom = h ? h + 'px' : ''; }
    function rbarShow(on) {
      if (!rbar) return;
      R.on = !!on && !!R.list; rbar.hidden = !R.on; rbar.classList.toggle('is-on', R.on);
      if (!R.on && rqp) { rqp.hidden = true; rqp.innerHTML = ''; }
      rbarPad();
    }
    function unitPrice() {
      var it = R.top; if (!it) return { p: 0, m: 0 };
      var p = it.per || it.p || 0;
      if (R.prod && R.vid) {
        var v = R.prod.variants.filter(function (x) { return x.id === +R.vid; })[0], dv = R.prod.variants.filter(function (x) { return x.available; })[0] || R.prod.variants[0];
        if (v && dv && dv.price) p = Math.round(v.price * ((it.per || it.p) / dv.price)); // keep any sale ratio the index price carries
      }
      var noSale = (it.tg || []).indexOf('no-sale') > -1;
      return { p: p, m: noSale ? p : Math.round(p * (100 - memberPct) / 100), noSale: noSale };
    }
    function rbarPrice() {
      var u = unitPrice(), n = R.qty, el = rin && rin.querySelector('[data-rb-price]'); if (!el) return;
      if (isMember && !u.noSale) el.innerHTML = '<b>' + money(u.m * n) + '</b> <span class="hmc-rbar__mem">Member price</span>';
      else el.innerHTML = '<b>' + money(u.p * n) + '</b>' + (!u.noSale && u.m < u.p ? ' <span class="hmc-rbar__mem">Members ' + money(u.m * n) + '</span>' : '');
      var t = rin.querySelector('[data-fit-tot]'); if (t) t.textContent = money((isMember && !u.noSale ? u.m : u.p) * n);
      var q = rin.querySelector('.fit-qty__n'); if (q) q.textContent = n;
    }
    function renderRbar() {
      if (!rin) return;
      var it = R.top, h;
      if (!it) {
        h = '<div class="hmc-rbar__main hmc-rbar__main--src"><p class="hmc-rbar__msg"><b>' + (R.wide ? 'Nothing in ' + esc(ctx.title || 'this range') + ' matched every answer.' : 'None of these fit every detail you gave.') + '</b> <span>We’ve shown the closest we have.</span></p>' + srcBtnHTML('data-rb-src', 'fit-src--bar') + '</div>' +
          '<div class="hmc-rbar__sub"><button type="button" class="fitbar__lk" data-rb-recheck><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>Re-check your answers</button></div>';
      } else {
        var vsel = '';
        if (R.prod && R.prod.variants.length > 1) vsel = '<label class="fitbar__var hmc-rbar__var"><span class="visually-hidden">Option</span><select data-rb-var aria-label="Option">' + R.prod.variants.map(function (v) { return '<option value="' + v.id + '"' + (+R.vid === v.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' — sold out') + '</option>'; }).join('') + '</select></label>';
        h = '<div class="hmc-rbar__main">' +
          '<a class="hmc-rbar__thumb" href="' + it.url + '" tabindex="-1" aria-hidden="true">' + (it.im ? '<img src="' + X.img(it.im, 120) + '" alt="" width="48" height="48" loading="lazy">' : '') + '</a>' +
          '<div class="hmc-rbar__info"><span class="hmc-rbar__eye">' + (R.list[0] === it ? 'Your top match' : 'Best match for your details') + '</span><a class="hmc-rbar__t" href="' + it.url + '">' + esc(it.t) + '</a><span class="hmc-rbar__p" data-rb-price></span></div>' +
          '<div class="hmc-rbar__buy">' + stepHTML('data-rb-step', R.qty) + '<button type="button" class="fit-add fit-add--bar" data-rb-add' + (R.vid ? '' : ' disabled') + '><span data-fit-add-l>Add to cart</span><span class="fit-add__pp"><b data-fit-tot></b></span></button></div></div>' +
          '<div class="hmc-rbar__sub">' + vsel +
          '<button type="button" class="fitbar__lk" data-rb-quote' + (R.vid ? '' : ' disabled') + '><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l5 5v13H7z M14 3v5h5 M10 13h6M10 17h6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round" stroke-linecap="round"/></svg>Add to quote</button>' +
          '<button type="button" class="fitbar__lk" data-rb-recheck><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>Re-check</button></div>';
      }
      rin.innerHTML = h;
      rbarPrice();
      rbarPad();
    }
    function showResultsBar(list, wide) {
      if (!rbar) return;
      R.list = list || []; R.wide = !!wide; R.qty = 1; R.prod = null; R.vid = null;
      // top match: the best-ranked product that is in stock and isn't "not your size" on the saved details
      R.top = wide ? null : R.list.filter(function (it) { return it.a && fitBadge(it).indexOf('hmc-fit--no') < 0; })[0] || null;
      renderRbar(); rbarShow(!open);
      if (R.top) {
        var h = R.top.h;
        productJS(h).then(function (prod) {
          if (!R.top || R.top.h !== h) return;
          R.prod = prod; var dv = prod.variants.filter(function (x) { return x.available; })[0] || prod.variants[0]; R.vid = dv && dv.id;
          renderRbar();
        }).catch(function () {});
      }
    }
    function rbToast(html) {
      if (!rqp) return;
      rqp.innerHTML = '<div class="fit-qp__card fit-qp__card--toast" role="status" aria-live="polite">' + html + '<button type="button" class="fit-qp__x" data-qp-close aria-label="Dismiss">×</button></div>';
      rqp.hidden = false;
      rqp.onclick = function (e) {
        if (e.target.closest('[data-qp-close]')) { rqp.hidden = true; rqp.innerHTML = ''; }
        if (e.target.closest('[data-cart-open]') && window.CWCart) { rqp.hidden = true; window.CWCart.open(); }
      };
      clearTimeout(rbToast.t); rbToast.t = setTimeout(function () { if (rqp.querySelector('.fit-qp__card--toast')) { rqp.hidden = true; rqp.innerHTML = ''; } }, 6000);
    }
    function showEnq(on) {
      enqMode = !!on && !!enq;
      if (!enq) return;
      enq.hidden = !enqMode; body.hidden = enqMode; prog.hidden = enqMode;
      if (enqMode) {
        var set = function (n, v) { var f = enq.querySelector('[name="contact[' + n + ']"]'); if (f) f.value = v; };
        set('Answers', ansSummary() || 'No answers given');
        var ta = enq.querySelector('textarea[name="contact[body]"]');
        if (ta && !ta.value.trim()) ta.value = 'Nothing in ' + (ctx.title || 'this range') + ' suited my answers' + (ansSummary() ? ' (' + ansSummary() + ')' : '') + '. Could you source something that does?';
        foot.innerHTML = '<div class="hmc-foot__row"><button type="button" class="hmc-link" data-enq-back>← Back to the questions</button><button type="button" class="hmc-link" data-close-panel>Close</button></div>';
        var first = enq.querySelector('input[name="contact[name]"]'); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
      } else renderFoot();
    }
    if (rbar) {
      rbar.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b || b.disabled) return;
        if (b.hasAttribute('data-rb-step')) { R.qty = Math.max(1, Math.min(99, R.qty + +b.getAttribute('data-rb-step'))); rbarPrice(); return; }
        if (b.hasAttribute('data-rb-recheck')) { prefill(); render(); openPanel(true); return; }
        if (b.hasAttribute('data-rb-src')) { prefill(); render(); openPanel(true); showEnq(true); return; }
        if (b.hasAttribute('data-rb-quote')) {
          var lbl = b.innerHTML; b.disabled = true;
          quoteAdd(R.top.h, R.vid, R.qty).then(function (r) { quotePrompt(rqp, r.prod.title + (r.v.title && r.v.title !== 'Default Title' ? ' (' + r.v.title + ')' : '')); })
            .catch(function () { rbToast('<p class="fit-qp__s">Sorry — the quote list isn’t available right now. Call <a href="tel:+61291254293">(02) 9125 4293</a>.</p>'); })
            .then(function () { b.disabled = false; b.innerHTML = lbl; });
          return;
        }
        if (b.hasAttribute('data-rb-add')) {
          var l = b.querySelector('[data-fit-add-l]'); b.disabled = true; b.classList.add('is-loading'); if (l) l.textContent = 'Adding…';
          directAdd(R.vid, R.qty).then(function (j) {
            var name = (j.items && j.items[0] && j.items[0].product_title) || R.top.t;
            b.classList.add('is-added'); if (l) l.textContent = 'Added ✓';
            rbToast('<p class="fit-qp__t"><span class="fit-qp__tick" aria-hidden="true">✓</span>Added to your cart</p><p class="fit-qp__s">' + (R.qty > 1 ? R.qty + ' × ' : '') + esc(name) + '</p><div class="fit-qp__btns"><button type="button" class="fit-qp__ghost" data-qp-close>Keep browsing</button><button type="button" class="fit-qp__go" data-cart-open>View cart <span aria-hidden="true">→</span></button></div>');
          }).catch(function (err) {
            if (l) l.textContent = 'Add to cart';
            rbToast('<p class="fit-qp__s">' + esc(err.message || 'Sorry, that could not be added.') + '</p>');
          }).then(function () { b.classList.remove('is-loading'); setTimeout(function () { b.classList.remove('is-added'); b.disabled = false; if (l) l.textContent = 'Add to cart'; }, 2200); });
        }
      });
      rbar.addEventListener('change', function (e) { if (e.target.matches('[data-rb-var]')) { R.vid = +e.target.value; rbarPrice(); } });
      window.addEventListener('resize', rbarPad);
    }

    /* --- events --- */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-hmc-open]');
      if (t) { e.preventDefault(); if (!open) { prefill(); render(); } openPanel(true); return; }
    });
    // the panel moves into the sidebar on desktop, so its listeners live on the panel itself (not on root)
    if (backdrop) backdrop.addEventListener('click', function () { openPanel(false); });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('button, a'); if (!b) return;
      if (b.hasAttribute('data-hmc-close') || b.hasAttribute('data-close-panel')) { openPanel(false); return; }
      if (b.matches('.hmc-opt')) {
        var q = qById(b.dataset.q), id = b.dataset.o, sel = answers[q.id] || [];
        if (q.multi) { var i = sel.indexOf(id); if (i > -1) sel.splice(i, 1); else sel.push(id); answers[q.id] = sel; }
        else { answers[q.id] = sel[0] === id ? [] : [id]; }
        delete autoFrom[q.id];
        if (q.weight && answers[q.id].length && !Mem.get().weight_kg) { /* remember the band loosely as a weight so other pages pre-fill */ var o = q.options.filter(function (x) { return x.id === id; })[0]; if (o && o.kg) Mem.set('weight_kg', o.kg); }
        if (q.height && answers[q.id].length) { var o2 = q.options.filter(function (x) { return x.id === id; })[0]; if (o2 && o2.cm && !Mem.get().height_cm) Mem.set('height_cm', o2.cm); }
        if (!q.multi && answers[q.id].length && cur < Q.length - 1) { cur++; }
        render(); return;
      }
      if (b.hasAttribute('data-go')) { cur = +b.dataset.go; render(); return; }
      if (b.hasAttribute('data-prev')) { cur--; render(); return; }
      if (b.hasAttribute('data-skip')) { cur++; render(); return; }
      if (b.hasAttribute('data-edit-auto')) { delete autoFrom[b.dataset.editAuto]; answers[b.dataset.editAuto] = []; render(); return; }
      if (b.hasAttribute('data-try')) { answers[Q[cur].id] = b.dataset.try; textCache = {}; render(); return; }
      if (b.hasAttribute('data-restart')) { reset(); if (C.hasPicks()) C.clearPicks({ silent: true }); render(); return; }
      if (b.hasAttribute('data-apply')) { apply(); return; }
      if (b.hasAttribute('data-enq-back')) { render(); return; }
    });
    panel.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-text-form]')) return;
      e.preventDefault();
      var inp = e.target.querySelector('[data-text]'); answers[inp.dataset.text] = inp.value.trim(); textCache = {}; render();
    });
    panel.addEventListener('input', function (e) {
      if (e.target.matches('[data-text]')) { answers[e.target.dataset.text] = e.target.value.trim(); textCache = {}; renderFoot(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) openPanel(false); });
    window.addEventListener('resize', place);
    trapFocus(panel);
    // drag handle: a downward swipe of 80px+ on the handle closes the sheet
    var handle = panel.querySelector('[data-hmc-handle]'), dy = null;
    if (handle) {
      handle.addEventListener('touchstart', function (e) { dy = e.touches[0].clientY; }, { passive: true });
      handle.addEventListener('touchmove', function (e) { if (dy !== null && e.touches[0].clientY - dy > 80) { dy = null; openPanel(false); } }, { passive: true });
      handle.addEventListener('touchend', function () { dy = null; });
    }
    document.addEventListener('cwcatalog:picks', function (e) { if (!e.detail) reset(); });
    window.addEventListener('popstate', function () { if (!Q.length) return; var has = readURL(); if (has) apply({ silent: true }); else if (C && C.hasPicks()) { C.clearPicks({ silent: true }); reset(true); } });

    /* search-within with zero results → whole range (spec §7) */
    document.addEventListener('cwcatalog:apply', function (e) {
      var d = e.detail || {};
      if (range && d.q && d.results && !d.results.length) range.run(d.q, 'Nothing in this collection matches “' + d.q + '” —');
      else if (range && !d.q && range.el.classList.contains('is-auto')) { range.el.classList.remove('is-auto'); range.run(''); }
      if (range && d.q && d.results && !d.results.length) range.el.classList.add('is-auto');
    });

    /* fit badges on every card the grid renders */
    function lookup(h) { var r = items.filter(function (it) { return it.h === h; })[0]; if (r) return r; if (all) return all.filter(function (it) { return it.h === h; })[0]; return range ? range.lookup(h) : null; }
    var grid = cat && cat.querySelector('[data-cat-grid]');
    if (grid && window.MutationObserver) new MutationObserver(function () { badgeGrid(grid, lookup); }).observe(grid, { childList: true });
    document.addEventListener('hmc:cards', function (e) { badgeGrid(e.detail.grid, lookup); });
    document.addEventListener('awfit:change', function () { if (grid) Array.prototype.forEach.call(grid.querySelectorAll('[data-hmc-badged]'), function (c) { c.removeAttribute('data-hmc-badged'); var b = c.querySelector('.hmc-fit'); if (b) b.remove(); }); badgeGrid(grid, lookup); });

    /* --- boot --- */
    function boot(list) {
      C = window.CWCatalog; // catalog.js is deferred after this script in the DOM, so it is picked up here, not at init
      items = list; collectionIds = {}; items.forEach(function (it) { collectionIds[it.i] = 1; });
      config(root.dataset.config).then(function (c) {
        cfg = c; fam = matchFamily(cfg, ctx); Q = expand(cfg, fam);
        // data-driven questions (weight rating, height) only when at least 30% of this collection can answer them
        Q = Q.filter(function (q) {
          if (!q.weight && !q.height) return true;
          var n = items.filter(function (it) { return q.weight ? wr(it) > 0 : !!(it.fit && (it.fit.handle_height_min_cm || it.fit.handle_height_max_cm)); }).length;
          return items.length > 0 && n / items.length >= 0.3;
        });
        root.dataset.family = fam.id;
        var t = panel.querySelector('[data-hmc-title]'); if (t) t.textContent = ctx.title ? 'Help me choose · ' + ctx.title : 'Help me choose';
        if (readURL()) apply({ silent: true });
        else if (open) { prefill(); render(); }
        if (enq && enq.querySelector('[data-hmc-sent]')) { prefill(); render(); openPanel(true); showEnq(true); }
        badgeGrid(grid, lookup);
      }).catch(function () { body.innerHTML = '<p class="hmc-q__h">Sorry — the questions couldn’t load. <a href="/pages/shop-the-home#help-me-choose">Try the full finder</a>.</p>'; });
    }
    if (C && C.ready()) boot(C.items());
    else document.addEventListener('cwcatalog:ready', function (e) { boot(e.detail.items); });
    // the index is already cached in sessionStorage most of the time, so this resolves instantly
  }

  /* =========================================================================
     6. PRODUCT MODE — "Is this right for me?" lives in assets/aw-fit-result.js (loaded before this file on product
        pages by snippets/aw-choose.liquid); it gets the shared internals below.
     ========================================================================= */
  var INTERNALS = { X: X, esc: esc, money: money, reduceMotion: reduceMotion, Mem: Mem, rx: rx, unconfirmedHas: unconfirmedHas, sizeOptions: sizeOptions, config: config, runChecks: runChecks, verdictOf: verdictOf, num: num, optionCard: optionCard, stepperHTML: stepperHTML, trapFocus: trapFocus, lockScroll: lockScroll, matchFamily: matchFamily, typeGroup: typeGroup, QA: QA, VLABEL: VLABEL, VICON: VICON, canBuy: canBuy, srcBtnHTML: srcBtnHTML, quoteAdd: quoteAdd, quotePrompt: quotePrompt, directAdd: directAdd, stepHTML: stepHTML };

  /* =========================================================================
     7. ACCOUNT MODE — "Your fit profile" card
     ========================================================================= */
  function accountMode(root) {
    var form = root.querySelector('form'), hidden = root.querySelector('[name="contact[Fit profile]"]'), status = root.querySelector('[data-fit-status]');
    function fill() { var m = Mem.get(); Mem.keys.forEach(function (k) { var f = root.querySelector('[data-fit-f="' + k + '"]'); if (f) f.value = m[k] == null ? '' : m[k]; }); }
    function collect() { var m = {}; Mem.keys.forEach(function (k) { var f = root.querySelector('[data-fit-f="' + k + '"]'); if (f && f.value !== '') m[k] = f.type === 'number' ? +f.value : f.value; }); return m; }
    fill();
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-fit-save-local]')) { Mem.write(collect()); if (status) status.textContent = 'Saved in this browser.'; }
      if (e.target.closest('[data-fit-clear]')) { Mem.write({}); fill(); if (status) status.textContent = 'Cleared.'; }
    });
    if (form) form.addEventListener('submit', function () { var m = collect(); Mem.write(m); if (hidden) hidden.value = JSON.stringify(m); });
  }

  /* =========================================================================
     boot
     ========================================================================= */
  function init() {
    var c = document.querySelector('[data-hmc]'); if (c) collectionMode(c);
    var p = document.querySelector('[data-fitcheck]'); if (p && window.AWFitProduct) window.AWFitProduct(p, INTERNALS);
    var a = document.querySelector('[data-fit-account]'); if (a) accountMode(a);
  }
  window.AWChoose = { mem: Mem, evalRule: evalRule, matchFamily: matchFamily, runChecks: runChecks, verdictOf: verdictOf };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
